'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

var EasyTips = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_easytips',
		offset: { x: 0, y: 0 },
		position: 'above', // above/top/up, below/bottom/down/under, leftside/left, rightside/right
		content: function content(_el) {
			return _el.getElement('.tooltip') || 'Use option \'content\' to set content to the tooltip';
		},
		parent: null
	},

	initialize: function initialize(elements, options) {
		this.setOptions(options);
		this._elements = elements;

		if (this._elements) {
			this.build();
		}
	},

	build: function build() {
		if (typeOf(this._elements) == 'element') {
			this._elements = [this._elements];
		}

		var opts = this.options;
		var self = this;

		this._container = new Element('.' + opts.cls);
		this._container.inject(document.body, 'bottom');
		this._tt_content = new Element('.w_easytips_content').inject(this._container);
		this._tt_tail = new Element('.w_easytips_tail').inject(this._container);

		this.intip = this.inelement = this.inparent = false;

		if (opts.parent) {
			opts.parent.addEvents({
				'mouseenter': function mouseenter() {
					self.inparent = true;
					if (self._current_el) self._current_el.addClass('_tipped');
				},

				'mouseleave': function mouseleave() {
					(function () {
						if (!self.intip && !self.inelement && !self.inparent) {
							self._container.hide();
							self._current_el = null;
						}
					}).delay(50);

					self.inparent = false;
					if (!self.inelement && !self.intip) {
						self.fireEvent('hide', [self._current_el]);
						if (self._current_el) self._current_el.removeClass('_tipped');
					}
				}
			});
		}

		this._container.addEvents({
			'mouseenter': function mouseenter() {
				self.intip = true;
				if (self._current_el) self._current_el.addClass('_tipped');
			},

			'mouseleave': function mouseleave() {
				(function () {
					if (!self.intip && !self.inelement && !self.inparent) {
						self._container.hide();
						self._current_el = null;
					}
				}).delay(50);

				self.intip = false;
				if (!self.inelement && !self.inparent) {
					self.fireEvent('hide', [self._current_el]);
					if (self._current_el) self._current_el.removeClass('_tipped');
				}
			}
		});

		this._elements.each(function (_el) {
			_el.addEvents({
				'mouseenter': function mouseenter() {
					self._container.show();

					if (self._current_el !== _el) {
						self.set_content(_el);
						self.set_position(_el);
						self.fireEvent('show', [_el]);
					}

					self.inelement = true;

					if (self._current_el) self._current_el.removeClass('_tipped');
					_el.addClass('_tipped');
					self._current_el = _el;
				},

				'mouseleave': function mouseleave() {
					(function () {
						if (!self.intip && !self.inelement && !self.inparent) {
							self._container.hide();
							self._current_el = null;
						}
					}).delay(50);

					self.inelement = false;

					if (!self.intip && !self.inparent) {
						self.fireEvent('hide', [_el]);
						if (self._current_el) self._current_el.removeClass('_tipped');
					}
				}
			});
		});

		document.addEvent('touchend', function (e) {
			if (e.target && self._current_el && e.target !== self._current_el) {
				self._current_el.fireEvent('mouseleave');
			}
		});
	},

	set_position: function set_position(_el) {
		var opts = this.options;
		var self = this;
		var left = _el.getCoordinates().left;
		var top = _el.getCoordinates().top;

		self._container.fade('hide');

		var el_width = _el.getAttribute('data-width') || _el.getSize().x;
		var el_height = _el.getAttribute('data-height') || _el.getSize().y;
		var cont_width = this._container.getSize().x;
		var cont_height = this._container.getSize().y;

		var shift_x;
		var shift_y;

		if (opts.position == 'above' || opts.position == 'top' || opts.position == 'up') {
			this._container.removeClass('_bottom').removeClass('_left').removeClass('_right').addClass('_top');

			shift_x = (el_width - cont_width) / 2;
			shift_y = -cont_height - this._tt_tail.getSize().y;
		} else if (opts.position == 'below' || opts.position == 'bottom' || opts.position == 'down' || opts.position == 'under') {
			this._container.removeClass('_top').removeClass('_left').removeClass('_right').addClass('_bottom');

			shift_x = (el_width - cont_width) / 2;
			shift_y = el_height + this._tt_tail.getSize().y;
		} else if (opts.position == 'rightside' || opts.position == 'right') {
			this._container.removeClass('_top').removeClass('_bottom').removeClass('_left').addClass('_right');

			shift_x = el_width + this._tt_tail.getSize().x;
			shift_y = (el_height - cont_height) / 2;
		} else {
			this._container.removeClass('_top').removeClass('_bottom').removeClass('_right').addClass('_left');

			shift_x = -cont_width - this._tt_tail.getSize().x;
			shift_y = (el_height - cont_height) / 2;
		}

		self._container.setStyles({
			'left': left + shift_x + opts.offset.x,
			'top': top + shift_y + opts.offset.y
		});

		self._container.fade('in');
	},

	set_content: function set_content(_el) {
		var type_of = typeOf(this.options.content);
		var content;

		if (type_of == 'function') {
			content = this.options.content(_el);
		} else {
			content = this.options.content;
		}

		if (typeOf(content) == 'element') {
			this._tt_content.empty();
			var _clone = content.clone();
			_clone.inject(this._tt_content);
			_clone.show();
			//_clone.cloneEvents(content);
			this.cloneEventsDeep(content, _clone);
		} else {
			this._tt_content.set('html', content);
		}
	},
	cloneEventsDeep: function cloneEventsDeep(from, to) {
		var self = this;
		to.cloneEvents(from);
		var fromChildren = from.getChildren();
		if (fromChildren.length > 0) {
			var toChildren = to.getChildren();
			fromChildren.each(function (item, index) {
				self.cloneEventsDeep(item, toChildren[index]);
			});
		}
	}
});
// Native.implement([Element, Window, Document], {

// });
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var HighstockExt = new Class({
	Extends: Highstock,

	options: {
		series_name: '',
		clickable: true,
		colors: ['#78cff6', '#aca000', '#008c99', '#c03e62', '#494a66', '#ff6a00'],
		chart: {
			chart: {
				renderTo: 'chart_container',
				backgroundColor: '#ebebeb',
				marginRight: 20
			},

			rangeSelector: {
				selected: 5,
				inputEnabled: false,
				labelStyle: {
					color: '#666'
				},
				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}],
				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				}
			},

			credits: {
				enabled: false
			},

			xAxis: {
				ordinal: false,
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: {
				plotLines: [{
					value: 0,
					width: 2,
					color: '666'
				}],

				title: {
					text: null,
					style: {
						color: '#666'
					}
				},

				labels: {
					style: {
						color: '#666'
					},
					y: -5,
					formatter: function formatter() {
						return '$' + this.value;
					}
				},

				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				showLastLabel: true,
				maxPadding: 0.06,
				opposite: false
			},

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					// lineWidth: 4,
					animation: true,
					cursor: 'pointer'
				},

				line: {
					dataGrouping: {
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		}
	},

	build: function build() {
		var x_label = this._element.getAttribute('data-x-label');
		var y_label = this._element.getAttribute('data-y-label');

		if (x_label && x_label.trim() != '') {
			this.options.chart.xAxis.title.text = this._element.getAttribute('data-x-label');
		}

		if (y_label && y_label.trim() != '') {
			this.options.chart.yAxis.title.text = this._element.getAttribute('data-y-label');
		}

		this._veil = this._element.getNext('.veil');

		var rpc = this.options.rpc || this._element.getAttribute('data-rpc');

		if (rpc && rpc != '') {
			this.rpc_request(rpc, this.post_rpc.bind(this));
		}

		this.series_options = [];

		this.series_options.push({
			name: this.options.series_name,
			color: this.options.colors[0]
		});
	},

	post_rpc: function post_rpc(options) {
		var self = this;
		var data = this.data || this.remote.get_data();

		if (options) {
			this.series_options[0].name = options.name;
			this.series_options[0].data = (options.data || data).data;
			if (this.options.clickable) {
				this.series_options[0].events = {
					click: function () {
						self.fireEvent('seriesClick');

						window.location = data.url;
					}.bind(this)
				};
			}
		} else {
			this.series_options[0].data = data.data;
			if (this.options.clickable) {
				this.series_options[0].events = {
					click: function () {
						self.fireEvent('seriesClick');

						window.location = data.url;
					}.bind(this)
				};
			}
		}

		datepickers.each(function (dp) {
			dp.hide();
		});

		if (this.series_options[0].data.length > 1) {
			if (this.chart) {
				this.chart.destroy();
				datepickers = [];
			}

			this.create_chart();
		} else {
			this._element.getParent().hide();
			this.show_warning(true);
		}

		if (this._veil) {
			this._veil.hide();
		}

		this.fireEvent('postRpc', [data]);
	},

	create_chart: function create_chart() {
		var self = this;
		var series_options = this.series_options.clean();
		var __date_difference = this.date_difference;

		this.move_rangeselector();

		var chart_options = this.options.chart;

		chart_options = Object.merge(chart_options, {
			series: series_options,

			tooltip: {
				useHTML: true,
				formatter: function formatter() {
					var details = '';

					this.points.each(function (e, i) {
						var point = e.point;
						var current = point.series.yData[point.series.yData.length - 1];
						var result = ((current - e.y.round()) / e.y.round() * 100).round(1);
						var sign = current >= Math.floor(e.y) ? '+' : '';
						result = sign + result.toString();

						var current_date = new Date();
						var from_date = new Date(Highcharts.dateFormat('%b %e, %Y', e.x));
						var xy = __date_difference(from_date, current_date);

						details += '<div class="series_name" style="border-bottom-color:' + point.series.color + '">' + point.series.name + '</div><br/>' + '<span>Current Price: <b>$' + Core.add_commas(current) + ' / ft<sup>2</sup></b></span><br/><br/>' + '<span style="color:#000">Price on ' + Highcharts.dateFormat('%b %e, %Y', e.x) + ': <b>$' + Core.add_commas(e.y) + ' / ft<sup>2</sup></b></span><br/>' + '<span>&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<label style="color:' + (sign == '+' ? 'green' : 'red') + '"/>' + result.toString() + '%</label></span>';

						if (self.options.clickable) {
							details += '<br/><br/><span style="color:#000">Click for index details</span><br/><br/>';
						}
					});

					return details;
				}
			},
			yAxis: {
				labels: {
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			}
		});

		this.chart = new Highcharts.StockChart(chart_options, function (chart) {
			setTimeout(function () {
				var _input_group = this._element.getElement('.highcharts-input-group');
				var _inputs = this._element.getElements('input.highcharts-range-selector', '#' + chart.options.chart.renderTo);

				if (_input_group) {
					//this is a workaround. close event from Date Picker widget is triggerred when clicking the input Date
					//need to cancel it.
					_input_group.addEvent('click', function (e) {
						e.stop();
					});
				}

				if (_inputs && _inputs.length > 1) {
					var min_date = new Date().parse(_inputs[0].get('value'));
					var max_date = new Date().parse(_inputs[1].get('value'));
				}

				_inputs.each(function (_el, i) {
					var min = min_date.clone();
					var max = max_date.clone();

					var dp = new Picker.Date(_el, {
						timePicker: true,
						draggable: false,
						minDate: i === 0 ? min : min.increment('day', 15),
						maxDate: i === 1 ? max : max.decrement('day', 15),
						pickOnly: 'days',
						pickerClass: 'datepicker_vista',
						format: "%m/%d/%Y",
						useFadeInOut: true,
						onSelect: function onSelect(dateText, input) {
							input.onchange();
							input.onblur();

							if (i == 0) {
								datepickers[1].options.minDate = dateText.increment('day', 15);
							} else if (i == 1) {
								datepickers[0].options.maxDate = dateText.decrement('day', 15);
							}
						}
					});

					datepickers.push(dp);

					_el.addEvent('focus', function () {
						datepickers.each(function (dp, j) {
							if (i != j) {
								dp.hide();
							}
						});
					});
				});
			}.bind(this), 0);
		}.bind(this));
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    topPosition = this.chart.plotTop - 18,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 410,
					y: topPosition
				});

				leftPosition += this.zoomText.getBBox().width + 410;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 14
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate;
		var toDate;
		var year;
		var month;
		var day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	cancel_request: function cancel_request() {
		if (this.remote) {
			this.remote.cancel();
		}
	},

	rebuild_chart: function rebuild_chart(_el) {
		this.data = _el.data;

		if (_el.data) {
			this.post_rpc({
				name: _el.get('text'),
				data: this.data
			});
		} else if (_el.rpc) {
			this.series_options[0].name = _el.get('text');

			this.rpc_request(_el.rpc, function () {
				this.post_rpc({
					name: _el.get('text'),
					data: _el.data
				});
			}.bind(this));
		}
	}
});
'use strict';

var MICP = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#a4b700', '#9ccdf3']
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');

		this._veil = this._element.getElement('.veil');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._region_select = this._element.getElement('.w_styled_select._regions select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.types = [2, 3];
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.region_id = this._region_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');
		this.currency_id = this._currency_select.getElement(':selected').get('value');

		this._yaxis_title1 = new Element('div', { 'class': 'yaxis_title _first', 'html': '<span>Condos (' + (this.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>' }).inject(this._graph_cont, 'after');
		this._yaxis_title2 = new Element('div', { 'class': 'yaxis_title _second', 'html': '<span>Co-ops (' + (this.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>' }).inject(this._yaxis_title1, 'after');

		this._yaxis_title1.setStyle('background-color', this.options.colors[0]);
		this._yaxis_title2.setStyle('background-color', this.options.colors[1]);

		if (Core.is_ie8()) {
			this._yaxis_title1.addClass('ie');
			this._yaxis_title2.addClass('ie');
		}

		this.get_active_currency_symbol();

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self._yaxis_title1.set('html', '<span>CONDOS (' + (self.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>');
			self._yaxis_title2.set('html', '<span>CO-OPS (' + (self.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>');

			self.fireEvent('filter');
		}.bind(this));

		this._region_select.addEvent('change', function () {
			self.region_id = self._region_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._currency_select.addEvent('change', function () {
			self.currency_id = self._currency_select.getElement(':selected').get('value');
			self.get_active_currency_symbol();
			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		this.fireEvent('filter');
	},

	get_active_currency_symbol: function get_active_currency_symbol() {
		var currency = this._currency_select.getElement(':selected').get('text');

		this.currency = currency.substring(0, currency.lastIndexOf(' '));
		this.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);
		this.currency_symbol = this.currency_symbol.trim();
	},

	get_data: function get_data() {
		var self = this;
		var type = '';

		this._veil.show();

		if (!this.data || !this.data[this.currency_id] || !this.data[this.currency_id][this.pricetype_id] || !this.data[this.currency_id][this.pricetype_id][this.region_id] || !this.data[this.currency_id][this.pricetype_id][this.region_id][this.beds_id]) {

			this.types.each(function (item) {

				self.store_data(self.currency_id, self.pricetype_id, self.region_id, self.beds_id);
				type += '&type[]=' + item;
			});
		}

		if (type == '') {
			this.display_chart();
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?currency=' + this.currency_id + '&show=' + this.pricetype_id + '&region=' + this.region_id + '&bedrooms=' + this.beds_id + type;

			var currency = this.currency_id,
			    pricetype = this.pricetype_id,
			    region = this.region_id,
			    beds = this.beds_id;

			new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), currency, pricetype, region, beds);

					self.display_chart();
				}
			});
		}
	},

	store_data: function store_data(data, currency, pricetype, region, beds) {
		var self = this;

		if (!this.data[currency]) this.data[currency] = {};
		if (!this.data[currency][pricetype]) this.data[currency][pricetype] = {};
		if (!this.data[currency][pricetype][region]) this.data[currency][pricetype][region] = {};
		if (!this.data[currency][pricetype][region][beds]) this.data[currency][pricetype][region][beds] = {};

		Object.each(data, function (el, i) {
			self.data[currency][pricetype][region][beds][i] = el;
		});
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		if (this.chart) {
			this.chart.destroy();
		}

		this.types.each(function (item) {
			if (item == 2) {
				series[0] = {
					name: 'CONDOS',
					data: self.data[self.currency_id][self.pricetype_id][self.region_id][self.beds_id][item],
					color: self.options.colors[0],
					yAxis: 0
				};
			} else {
				series[1] = {
					name: 'CO-OPS',
					data: self.data[self.currency_id][self.pricetype_id][self.region_id][self.beds_id][item],
					color: self.options.colors[1],
					yAxis: 1
				};
			}
		});

		this.move_rangeselector();

		var min = null,
		    max = null;
		var second_grid_width = 0;

		series[0].data.each(function (el) {
			if (!min || min > el[1]) {
				min = el[1];
			}

			if (!max || max < el[1]) {
				max = el[1];
			}
		});

		series[1].data.each(function (el) {
			if (!min || min > el[1]) {
				min = el[1];
			}

			if (!max || max < el[1]) {
				max = el[1];
			}
		});

		this.chart = new Highcharts.StockChart({
			chart: {
				renderTo: self._graph_cont,
				type: 'spline',
				backgroundColor: '#ebebeb',
				marginTop: 25
			},

			series: series,

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				selected: 5,
				inputEnabled: false,

				labelStyle: {
					color: '#666'
				},

				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				},

				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}]
			},

			credits: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: [{
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					style: {
						color: '#666'
					},
					y: -5,
					x: 0,
					formatter: function formatter() {
						var currency_code = self._currency_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol;
						}

						return self.currency_symbol + Core.add_commas(this.value);
					}
				},

				// endOnTick: false,
				showLastLabel: true,
				gridLineWidth: 1,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				opposite: false
			}, {
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					enabled: false

					// style: {
					//	 color: '#eee'
					// },
					// y: -5,
					// formatter: function() {
					//	 var currency_code = self._currency_select.getElement(':selected').get('value');

					//	 if(currency_code == 'RUB'){
					//		 return Core.add_commas(this.value) + ' ' + self.currency_symbol;
					//	 }else if(currency_code == 'XAU'){
					//		 return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol;
					//	 }

					//	 return self.currency_symbol + Core.add_commas(this.value);
					// }
				},

				gridLineWidth: second_grid_width,
				opposite: true

				// endOnTick: false,
				// gridLineDashStyle: 'dash',
				// showLastLabel: true,
				// gridLineColor: '#484848'
			}],

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 100,
					type: 'datetime',
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					},
					gridLineColor: '#888',
					gridZIndex: 4
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					animation: true,
					events: {
						click: function click(e) {
							var type_id = this.name == 'CONDOS' ? 2 : 3;
							var _apartment_prices_option = self._element.getElement('.w_graph_categories .apartment_prices');

							if (!_apartment_prices_option) return;

							_apartment_prices_option.fireEvent('click');

							self.fireEvent('show_in_apartment_prices', [self.region_id, type_id, self.beds_id, self.pricetype_id, self.currency_id]);
						}
					}
				},

				// line: {
				//	 lineWidth: 3,

				//	 states: {
				//		 hover: {
				//			 lineWidth: 3
				//		 }
				//	 },

				//	 marker: {
				//		 enabled: false,
				//		 states: {
				//			 hover: {
				//				 enabled: false
				//			 }
				//		 }
				//	 },

				//	 dataGrouping: {
				//		 // groupPixelWidth: 5,
				//		 approximation: 'open',
				//		 // forced: true,
				//		 dateTimeLabelFormats: {
				//			 day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
				//			 week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
				//		 }
				//	 }
				// },

				spline: {
					lineWidth: 3,

					states: {
						hover: {
							lineWidth: 4
						}
					},

					marker: {
						enabled: false
					},

					dataGrouping: {
						groupPixelWidth: 10,
						approximation: 'open',
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			tooltip: {
				useHTML: true,
				valueDecimals: 0,
				shared: true,
				crosshairs: false,
				borderWidth: 2,
				borderColor: '#999',

				formatter: function formatter() {
					return self.get_tooltip(this);
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		});

		this._veil.hide();
	},

	get_tooltip: function get_tooltip(obj) {
		var self = this;

		var details, c_price1, h_price1, c_price2, h_price2;
		var current1 = obj.points[0].series.yData[obj.points[0].series.yData.length - 1];
		var current2 = obj.points[1] ? obj.points[1].series.yData[obj.points[1].series.yData.length - 1] : '';

		var result1 = ((current1 - obj.points[0].y.round()) / obj.points[0].y.round() * 100).round(1);

		if (current2 != '') {
			var result2 = ((current2 - obj.points[1].y.round()) / obj.points[1].y.round() * 100).round(1);
		}

		var current_date = new Date();
		var fromDate = new Date(Highcharts.dateFormat('%b %e, %Y', obj.points[0].x));
		var xy = self.date_difference(fromDate, current_date);

		if (this._currency_select.getElement(':selected').get('value') == 'XAU') {
			result1 = ((current1.round(1) - obj.points[0].y.round(1)) / obj.points[0].y.round(1) * 100).round(1);
			c_price1 = Core.add_commas(current1.toFixed(1)) + ' ' + self.currency_symbol;
			h_price1 = Core.add_commas(obj.points[0].y.toFixed(1)) + ' ' + self.currency_symbol;
		} else if (this._currency_select.getElement(':selected').get('value') == 'RUB') {
			c_price1 = Core.add_commas(current1) + ' ' + self.currency_symbol;
			h_price1 = Core.add_commas(obj.points[0].y) + ' ' + self.currency_symbol;
		} else {
			c_price1 = self.currency_symbol + Core.add_commas(current1);
			h_price1 = self.currency_symbol + Core.add_commas(obj.points[0].y.round());
		}

		if (current2 != '') {
			if (this._currency_select.getElement(':selected').get('value') == 'XAU') {
				result2 = ((current2.round(1) - obj.points[1].y.round(1)) / obj.points[1].y.round(1) * 100).round(1);
				c_price2 = Core.add_commas(current2.toFixed(1)) + ' ' + self.currency_symbol;
				h_price2 = Core.add_commas(obj.points[1].y.toFixed(1)) + ' ' + self.currency_symbol;
			} else if (this._currency_select.getElement(':selected').get('value') == 'RUB') {
				c_price2 = Core.add_commas(current2) + ' ' + self.currency_symbol;
				h_price2 = Core.add_commas(obj.points[1].y) + ' ' + self.currency_symbol;
			} else {
				c_price2 = self.currency_symbol + Core.add_commas(current2);
				h_price2 = self.currency_symbol + Core.add_commas(obj.points[1].y.round());
			}
		}

		var sign1 = current1.round(1) >= obj.points[0].y.round(1) ? '+' : '';
		result1 = sign1 + result1.toString();

		if (current2 != '') {
			var sign2 = current2.round(1) >= obj.points[1].y.round(1) ? '+' : '';
			result2 = sign2 + result2.toString();
		}

		details = '<div class="tooltip">' + '<div class="series_name" style="background-color:' + obj.points[0].series.color + '">' + obj.points[0].series.name + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[0].x) + ': ' + '<b style="">' + h_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign1 == '+' ? 'green' : 'red') + '"/>' + result1.toString() + '%</span>' + '</div><br/>';

		if (current2 != '') {

			details += '<div class="series_name" style="background-color:' + obj.points[1].series.color + '">' + obj.points[1].series.name + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[1].x) + ': ' + '<b style="">' + h_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign2 == '+' ? 'green' : 'red') + '"/>' + result2.toString() + '%</span>' + '</div>';
		}

		details += '<br/><span>Click on the line for more detail.</span></div>';

		return details;
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate, toDate;
		var year, month, day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft - 15,
				    topPosition = this.chart.plotTop,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 415,
					y: topPosition - 56
				});

				leftPosition += this.zoomText.getBBox().width + 420;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 70
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var MIBC = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#ff6a00', '#c03e62', '#a7b568', '#00aeef', '#494a66', '#aca000', '#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00', '#a4b700', '#008ad9', '#b901fd', '#484a67', '#fa9a02', '#e20101', '#00c09e', '#139d05', '#010fca', '#672466', '#fe7a7a', '#a87b01'],
		unselected_item_color: '#d0d0d0',
		move_on_mousewheel: true
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');
		this._warning = this._element.getElement('.warning');
		this._veil = this._element.getElement('.veil');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._type_select = this._element.getElement('.w_styled_select._type select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		this._beds_options = this._element.getElements('.w_styled_select._beds .option');
		this._pricetype_options = this._element.getElements('.w_styled_select._price_types .option');
		this._currency_options = this._element.getElements('.w_styled_select._currencies .option');
		this._regions = this._element.getElements('.regions li');

		if (Cookie.read('from_mbc') == 'true') {
			this.fireEvent('apply_previous_filter');
			Cookie.write('from_mbc', false);
		}

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.type_id = this._type_select.getElement(':selected').get('value');
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.curr_id = this._currency_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');

		self.y_axis_title = self._pricetype_select.getElement(':selected').get('data-text');
		self.x_axis_title = this._element.getElement('.x_axis_title').get('text');

		this.data_changed = true;

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		this._type_select.addEvent('change', function () {
			self.type_id = self._type_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self.y_axis_title = self._pricetype_select.getElement(':selected').get('data-text');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		var currency = this._currency_select.getElement(':selected').get('text');
		this.currency = currency.substring(0, currency.lastIndexOf(' '));
		this.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

		this._currency_select.addEvent('change', function () {
			self.curr_id = self._currency_select.getElement(':selected').get('value');

			self.data_changed = true;

			var currency = self._currency_select.getElement(':selected').get('text');
			self.currency = currency.substring(0, currency.lastIndexOf(' '));
			self.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		var back_button = this._element.getElement('.back_to_regions');

		if (back_button) {
			back_button.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				var url = self._element.getAttribute('data-url') + '?area=region' + '&type=' + self.type_id + '&show=' + self.pricetype_id + '&currency=' + self.curr_id + '&bedrooms=' + self.beds_id;

				window.location = url;
			});
		}

		this._regions = this._element.getElements('.regions li');

		this.regions = {};

		this._regions.each(function (_el, i) {
			_el.index = _el.get('data-id');
			self.regions[_el.index] = _el.get('text').trim();

			var color = self.options.colors[i];
			self.colors.push(color);
			_el.color = color;

			if (_el.hasClass('_selected')) {
				_el.setStyle('background-color', color);
			} else {
				_el.setStyle('background-color', self.options.unselected_item_color);
			}

			_el.setStyle('border-color', color);

			var config;

			try {
				config = JSONMOO.decode(_el.getElement('.hoods').get('html'), false);
			} catch (e) {}

			if (typeOf(config) == 'object') {
				_el.hoods = config;
			}

			_el.addEvents({
				'click': function click() {
					_el.toggleClass('_selected');

					if (_el.getStyle('background-color').toLowerCase() == self.colors[i].toLowerCase()) {
						_el.setStyles({
							'background-color': self.options.unselected_item_color
						});
					} else {
						_el.setStyles({
							'background-color': _el.color
						});
					}

					self.fireEvent('filter');
				}
			});
		});

		this.fireEvent('filter');
	},

	get_data: function get_data() {
		var self = this;
		var region = '';

		this._veil.show();

		this.area = 'region'; //this._element.getElement('.w_graph_legends').getAttribute('data-area');

		if (!this.data || !this.data[this.type_id] || !this.data[this.type_id][this.pricetype_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id][this.beds_id]) {

			this._regions.each(function (_el) {
				if (_el.hasClass('_selected')) {
					var obj;
					try {
						obj = JSONMOO.decode('{"' + _el.index + '": "waiting"}', false);
					} catch (e) {}

					self.store_data(obj, self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		} else {
			this._regions.each(function (_el) {
				if (_el.hasClass('_selected') && !self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index]) {
					self.store_data(JSON.parse('{"' + _el.index + '": "waiting"}'), self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		}

		if (region == '') {
			this.display_chart();
			this.fireEvent('set_cookie');
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?area=' + this.area + '&type=' + this.type_id + '&show=' + this.pricetype_id + '&currency=' + this.curr_id + '&bedrooms=' + this.beds_id + region;

			var aptype = this.type_id,
			    pricetype = this.pricetype_id,
			    region = this.curr_id,
			    beds = this.beds_id;

			this.remote = new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), aptype, pricetype, region, beds);

					self.display_chart();

					self.fireEvent('set_active_regions');
					self.fireEvent('set_cookie');
				}
			});
		}
	},

	store_data: function store_data(data, aptype, pricetype, currency, beds) {
		var self = this;

		if (!this.data[aptype]) this.data[aptype] = {};
		if (!this.data[aptype][pricetype]) this.data[aptype][pricetype] = {};
		if (!this.data[aptype][pricetype][currency]) this.data[aptype][pricetype][currency] = {};
		if (!this.data[aptype][pricetype][currency][beds]) this.data[aptype][pricetype][currency][beds] = {};

		Object.each(data, function (el, i) {
			self.data[aptype][pricetype][currency][beds][i] = el;
		});
	},

	sort_series: function sort_series(array, order) {
		this.array_to_sort = array;
		this.quick_sort(0, this.array_to_sort.length - 1, 'desc');
		return this.array_to_sort;
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.array_to_sort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.array_to_sort[left].price + '' >= center.price + '') {
						left++;
					}

					while (left <= right && this.array_to_sort[right].price + '' < center.price + '') {
						right--;
					}
				} else {
					while (left <= right && this.array_to_sort[left].price >= center.price) {
						left++;
					}

					while (left <= right && this.array_to_sort[right].price < center.price) {
						right--;
					}
				}

				if (left < right) {
					temp = this.array_to_sort[right];
					this.array_to_sort[right] = this.array_to_sort[left];
					this.array_to_sort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.array_to_sort[right];
			this.array_to_sort[right] = this.array_to_sort[first];
			this.array_to_sort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		var min, max;

		this._regions.each(function (_el, i) {
			if (!self.data[self.type_id]) self.data[self.type_id] = {};
			if (!self.data[self.type_id][self.pricetype_id]) self.data[self.type_id][self.pricetype_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id]) self.data[self.type_id][self.pricetype_id][self.curr_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id]) self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id] = {};

			var data = self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index];

			if (_el.hasClass('_selected') && data && data != 'waiting' && data != []) {
				data.each(function (el) {
					el.color = self.colors[i];
					series.push(el);

					if (!min || min > el.price) {
						min = el.price;
					}

					if (!max || max < el.price) {
						max = el.price;
					}
				});
			}
		});

		this.display_warning(series.length == 0);

		if (series.length == 0) {
			this._veil.hide();
			return;
		}

		self._graph_cont.set('html', '<div class="columns' + (Core.is_ie8() ? ' _old_ie' : '') + '"></div>');

		if (Core.is_ie8()) {
			self._element.addClass('_old_ie');
		}

		series = this.series = this.sort_series(series, 'desc');

		var _columns = self._graph_cont.getElement('.columns');

		var log_min = self.log2(min);
		var log_max = self.log2(max);

		log_min = this.is_integer(log_min) ? log_min - 0.1 : log_min;
		log_max = this.is_integer(log_max) ? log_max + 0.1 : log_max;

		var log_width = Math.ceil(log_max * 10) - Math.floor(log_min * 10) + 10;
		// var log_width = Math.ceil(log_max*10) - Math.floor(log_min*10);
		var max_height = _columns.getSize().x;
		var coef = max_height / log_width;

		while (max_height - coef * (self.log2(series[0].price) - Math.floor(log_min)) * 10 > max_height / 8) {
			log_width--;
			coef = max_height / log_width;
		}

		var real_width;

		(function () {
			series.each(function (el, i) {
				_columns.adopt(new Element('div', { 'class': 'column_name', 'text': el.name }));
				var _column = new Element('div', { 'class': 'column_body', 'data-class': 'w_blimp_bld', 'style': 'background-color: ' + el.color, 'data-rpc': el.url });
				if (i == series.length - 1) {
					_column.setStyle('margin-bottom', 0);
				}

				_column.addEvent('click', function () {
					self._veil.show();
				});

				var blimp = new BlimpExt(_column, {
					draggable: true,
					show_veil: true,
					onPostRpc: function onPostRpc() {
						new BldBlimp(this);

						self.fireEvent('columnClick');
					}
				});

				blimp.addEvent('show', function () {
					self._veil.hide();
					Cookie.write('from_mbc', true);
				});

				blimp.addEvent('hide', function () {
					Cookie.write('from_mbc', false);
				});

				self.set_tooltip(el, _column);
				_columns.adopt(_column);

				var width = 0;

				if (el.price > 0) {
					width = coef * (self.log2(el.price) - Math.floor(log_min)) * 10;
				}

				_column.setStyle('width', width);
			});

			var easytips = this.easytips = new EasyTips(this._graph_cont.getElements('.column_body'), { 'parent': this._graph_cont });

			easytips.addEvent('show', function () {
				var _img = this._container.getElement('img');
				_img.set('src', _img.getAttribute('data-src'));
			});

			this.create_grid(coef, max, log_min);

			this._veil.hide();
			this.data_changed = false;
			this.add_hscroll(_columns, this._graph_cont);
		}).bind(this).delay(50); //delay is needed for big data charts
	},
	set_tooltip: function set_tooltip(el, _column) {
		var self = this;
		var price;
		if (self.curr_id == 'XAU' || self.curr_id == 'RUB') {
			price = Core.add_commas(el.price) + ' ' + self.currency_symbol;
		} else {
			price = self.currency_symbol + Core.add_commas(el.price);
		}

		var _tooltip_content = new Element('.tooltip').inject(_column);
		var _bulb = new Element('div', {
			'class': 'w_columnchart_bulb _buildings clearfix',
			'html': '<img data-src="' + el.image + '" onerror="this.src=\'' + el.missing_img + '\';">' + '<div class="info"></div>'
		}).inject(_tooltip_content);

		var content = _bulb.getElement('.info');

		var _bulb_name = new Element('a.name').inject(content);
		_bulb_name.set('text', el.name || el.address);
		_bulb_name.addEvent('click', function (e) {
			e.stopPropagation();
			window.location = el.building_url;
		});

		var _bulb_address = new Element('a.address').inject(content);
		_bulb_address.set('text', el.address);
		_bulb_address.addEvent('click', function (e) {
			e.stopPropagation();
			window.location = el.building_url;
		});

		var _bulb_price = new Element('span.price').inject(content);
		_bulb_price.set('html', price + ' / ft<sup>2</sup>');

		var _bulb_sales = new Element('span.sales').inject(content);
		_bulb_sales.set('text', ' Based on ' + el.transactions_ppsqft + (el.transactions_ppsqft.toInt() > 1 ? ' sales' : ' sale') + ' in past 12 months');

		if (el.sale && el.sale.available > 0) {
			var _bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
			var apts = el.sale.available > 1 ? 'Apts' : 'Apt';
			_bulb_available_for_sale.set('html', apts + ' for Sale: ' + el.sale.available);
			_bulb_available_for_sale.addEvent('click', function (e) {
				e.stopPropagation();
				Cookie.write('crBovJumpTo', 'sale');
				window.location = el.building_url;
			});
		}

		if (el.rent && el.rent.available > 0) {
			var _bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
			var apts = el.rent.available > 1 ? 'Apts' : 'Apt';
			_bulb_available_for_rent.set('html', apts + ' for Rent: ' + el.rent.available);
			_bulb_available_for_rent.addEvent('click', function (e) {
				e.stopPropagation();
				Cookie.write('crBovJumpTo', 'rent');
				window.location = el.building_url;
			});
		}
		_bulb.set('data-class', 'w_blimp_bld');
		_bulb.set('href', el.url);

		new BlimpExt(_bulb, {
			draggable: true,
			show_veil: true,
			onPostRpc: function onPostRpc() {
				new BldBlimp(this);
			}
		});
	},
	create_grid: function create_grid(coef, max, log_min) {
		var self = this;

		var _scale = this._element.getElement('.w_graph_scale').set('html', '<div class="y_axis_title' + (Core.is_ie8() ? ' _old_ie' : '') + '">' + self.y_axis_title + ' in ' + self.currency + (self.curr_id == 'XAU' ? '' : 's') + '</div>');

		if (Core.is_ie8()) {
			this._element.getElement('.x_axis_title').set('html', self.y_axis_title);
			this._element.getElement('.y_axis_title').set('html', self.x_axis_title);
			return;
		}

		var grid_lines_amount = (max / Math.pow(10, String.from(max.round()).length - 1)).round();
		var grid_lines_step = grid_lines_amount * Math.pow(10, String.from(max.round()).length - 1) / grid_lines_amount;

		if (grid_lines_amount == 1) {
			grid_lines_amount = 2;
			grid_lines_step /= 2;
		}

		if (self.curr_id == 'XAU') {
			grid_lines_step = grid_lines_step.round(2);
		} else {
			grid_lines_step = grid_lines_step.round();
		}

		var scale_height = _scale.getSize().y - 10;

		for (var i = grid_lines_amount; i >= 0; i--) {
			var label_text;
			var label_value = i > 0 ? grid_lines_step * i : grid_lines_step / 2;

			if (self.curr_id == 'XAU') {
				label_text = label_value + (self.is_integer(label_value) ? '.0 ' : ' ') + self.currency_symbol.toLowerCase();
			} else if (self.curr_id == 'RUB') {
				label_text = Core.add_commas(label_value) + ' ' + self.currency_symbol.toLowerCase();
			} else {
				label_text = self.currency_symbol + Core.add_commas(label_value);
			}

			var _grid_line = new Element('div', { 'class': 'grid_element', 'html': '<span class="label">' + label_text + '</span>', 'data-value': label_value });
			_grid_line.inject(_scale);

			var bottom = coef * (self.log2(label_value) - Math.floor(log_min)) * 10 - 1;

			if (bottom > 10 && bottom < scale_height) {
				_grid_line.setStyle('bottom', bottom);
			} else {
				_grid_line.dispose();
			}
		}

		if (_scale.getElements('.grid_element').length == 1) {
			var _another_grid_line = _scale.getElement('.grid_element').clone();

			var label_value = _another_grid_line.get('data-value') / 4 * 3;

			if (self.curr_id == 'XAU') {
				label_text = label_value + (self.is_integer(label_value) ? '.0 ' : ' ') + self.currency_symbol.toLowerCase();
			} else if (self.curr_id == 'RUB') {
				label_text = Core.add_commas(label_value) + ' ' + self.currency_symbol.toLowerCase();
			} else {
				label_text = self.currency_symbol + Core.add_commas(label_value);
			}

			_another_grid_line.getElement('.label').set('text', label_text);

			var bottom = coef * (self.log2(label_value) - Math.floor(log_min)) * 10 - 1;

			if (bottom > 10 && bottom < scale_height) {
				_another_grid_line.inject(_scale);
				_another_grid_line.setStyle('bottom', bottom);
			}
		}
	},

	log2: function log2(val) {
		return Math.log(val) / Math.log(2);
	},

	is_integer: function is_integer(num) {
		return num.round() == num || num.round(1) - num.round() == 0;
	},

	add_hscroll: function add_hscroll(_child, _parent) {
		if (Core.is_ie8()) return;

		var _name = _child.getElement('.column_name');
		var _body = _child.getElement('.column_body');

		var element_width = _name.getSize().x + _name.getStyle('margin-top').toInt() + _name.getStyle('margin-bottom').toInt() + _body.getSize().x + _body.getStyle('margin-top').toInt() + _body.getStyle('margin-bottom').toInt();

		var child_width = element_width * this.series.length - _body.getStyle('margin-bottom').toInt();

		if (child_width <= _parent.getSize().x && !_hscroll) {

			if (this._hscroll) {
				this._hscroll.dispose();
			}

			var _hscroll = this._hscroll = new Element('div', { 'class': 'hscroller' });
			_hscroll.inject(this._graph_cont, 'after');

			return;
		}

		var self = this;
		var opts = this.options;

		var animate = new Fx.Scroll(_parent, {
			link: 'cancel',
			duration: 700,
			transition: Fx.Transitions.Quad.easeOut,
			wheelStops: false
		});

		if (this._hscroll) {
			this._hscroll.removeEvents();
			this._hscroll.dispose();
		}

		var _hscroll = this._hscroll = new Element('div', { 'class': 'hscroller', 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._graph_cont, 'after');

		var indragger = false;

		var init_pos = 0;

		var _dragger = _hscroll.getElement('.dragger'),
		    disp_col = Math.ceil((_parent.getSize().x + _body.getStyle('margin-bottom').toInt()) / element_width),
		    size_coefficient = Math.ceil(this.series.length - disp_col);

		var dragger_left = 0;

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = _hscroll.getSize().x - dr_size;

		_hscroll.addEvents({
			'click': function click(e) {
				if (!indragger) {
					var to = animate.to ? animate.to[0] : 0;

					if (e.page.x - _hscroll.getCoordinates().left > _dragger.getStyle('left').toInt()) {
						animate.start(to + element_width * (disp_col - 1), 0);
					} else {
						animate.start(to - element_width * (disp_col - 1), 0);
					}

					if (animate.to[0] >= child_width - _parent.getSize().x) {
						_dragger.setStyle('left', max_left);
						return;
					}

					var percent_left = animate.to[0] * 100 / child_width;
					var left = (_hscroll.getSize().x - dr_size) * percent_left / 100;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);
				}
			},

			'mouseenter': function mouseenter() {
				if (self.dragging != true) _parent.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) _parent.removeClass('dragging');
			}
		});

		_dragger.addEvents({
			'mousedown': function mousedown(e) {
				self.dragging = true;
				dragger_left = _dragger.getStyle('left').toInt();
				init_pos = e.page.x;
				return false;
			},

			'mouseenter': function mouseenter() {
				indragger = true;
			},
			'mouseleave': function mouseleave() {
				indragger = false;
			}
		});

		document.addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var hposition = left * ((child_width - 400) / max_left);
					animate.set(hposition, 0);

					if (!animate.to) animate.to = [0, 0];

					animate.to[0] = hposition;
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				// _parent.removeClass('dragging');
			}
		});

		if (opts.move_on_mousewheel) {
			this._graph_cont.addEvent('mousewheel', function (e) {
				if (e && e.stop) e.stop();

				if (e.wheel > 0) {
					var ev = { page: { x: 1, y: 0 } };
					_hscroll.fireEvent('click', [ev]);
				} else if (e.wheel < 0) {
					var ev = { page: { x: _hscroll.getSize().x - 1 + _hscroll.getPosition().x, y: 0 } };
					_hscroll.fireEvent('click', [ev]);
				}

				self.easytips._container.hide();
			});
		}
	},

	display_warning: function display_warning(show) {
		if (show) {
			var msg = 'No data available for ' + this._beds_select.getElement(':selected').get('text') + ' apartments in the selected ' + (this.area == 'region' ? 'regions' : 'neighborhoods');

			this._warning.set('text', msg);
			this._warning.show();
			this._graph_cont.hide();
			this._element.getElement('.w_graph_scale').hide();
			this._element.getElement('.x_axis_title').hide();
			this._element.getElement('.w_graph_disclaimer').hide();
		} else {
			this._warning.hide();
			this._graph_cont.show();
			this._element.getElement('.w_graph_scale').show();
			this._element.getElement('.x_axis_title').show();
			this._element.getElement('.w_graph_disclaimer').show();
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var MICC = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#a4b700', '#9ccdf3']
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');

		this._veil = this._element.getElement('.veil');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._type_select = this._element.getElement('.w_styled_select._type select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._region_select = this._element.getElement('.w_styled_select._regions select');

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.type_id = this._type_select.getElement(':selected').get('value');
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.region_id = this._region_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');

		this._cur1_select = this._element.getElement('.w_styled_select._currency1');
		this._cur2_select = this._element.getElement('.w_styled_select._currency2');

		this._yaxis_title1 = new Element('div', { 'class': 'yaxis_title _first', 'html': '<span>' + (this.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in US DOLLARS</span>' }).inject(this._graph_cont, 'after');
		this._yaxis_title2 = new Element('div', { 'class': 'yaxis_title _second', 'html': '<span>' + (this.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in EUROS</span>' }).inject(this._yaxis_title1, 'after');

		this._yaxis_title1.setStyle('background-color', this.options.colors[0]);
		this._yaxis_title2.setStyle('background-color', this.options.colors[1]);

		if (Core.is_ie8()) {
			this._yaxis_title1.addClass('ie');
			this._yaxis_title2.addClass('ie');
		}

		this.set_selects_functionality();

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._type_select.addEvent('change', function () {
			self.type_id = self._type_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self._yaxis_title1.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency1 + (self.currency1.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');
			self._yaxis_title2.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency2 + (self.currency2.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');
			self.fireEvent('filter');
		});

		this._region_select.addEvent('change', function () {
			self.region_id = self._region_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		this._currencies = this._element.getElements('.currencies li');
		this.first_currency = 'USD';

		this._currencies.each(function (_el) {
			self.colors.push(_el.getElement('.symbol').getStyle('color'));
			_el.index = _el.get('class').toUpperCase();

			if (_el.index == self._cur1_select.getElement(':selected').get('value') || _el.index == self._cur2_select.getElement(':selected').get('value')) {
				_el.addClass('_selected');
			}
		});

		this.fireEvent('filter');
	},

	set_selects_functionality: function set_selects_functionality() {
		var self = this;

		this._cur1_select.getElements('li').each(function (_el, i) {
			_el.set('data-value', self._cur1_select.getElements('option')[i].get('value'));
		});

		this._cur2_select.getElements('li').each(function (_el, i) {
			_el.set('data-value', self._cur2_select.getElements('option')[i].get('value'));
		});

		var cur1 = this._cur1_select.getElement('.selected').getAttribute('data-value');
		this._cur2_select.getElements('li').each(function (_el) {
			if (cur1 == _el.getAttribute('data-value')) {
				_el.addClass('hidden');
			}
		});

		var cur2 = this._cur2_select.getElement('.selected').getAttribute('data-value');
		this._cur1_select.getElements('li').each(function (_el) {
			if (cur2 == _el.getAttribute('data-value')) {
				_el.addClass('hidden');
			}
		});

		var currency1 = this._cur1_select.getElement(':selected').get('text');
		var currency2 = this._cur2_select.getElement(':selected').get('text');

		this.currency1 = currency1.substring(0, currency1.lastIndexOf(' '));
		this.currency2 = currency2.substring(0, currency2.lastIndexOf(' '));
		this.currency_symbol1 = currency1.substring(currency1.lastIndexOf(' '), currency1.length);
		this.currency_symbol2 = currency2.substring(currency2.lastIndexOf(' '), currency2.length);

		this._cur1_select.getElement('select').addEvent('change', function (el) {
			self._cur2_select.getElement('li.hidden').removeClass('hidden');
			self._cur2_select.getElements('li').each(function (_el) {
				if (el.get('value') == _el.getAttribute('data-value')) {
					_el.addClass('hidden');
				}
			});

			cur2 = self._cur2_select.getElement('.selected').getAttribute('data-value');

			self._currencies.each(function (_el) {
				if (_el.index == el.get('value') || _el.index == cur2) {
					_el.addClass('_selected');
				} else {
					_el.removeClass('_selected');
				}
			});

			self.first_currency = el.get('value');

			currency1 = el.get('text');
			self.currency1 = currency1.substring(0, currency1.lastIndexOf(' '));
			self.currency_symbol1 = currency1.substring(currency1.lastIndexOf(' '), currency1.length);

			self._yaxis_title1.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency1 + (self.currency1.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');

			self.fireEvent('filter');
		});

		this._cur2_select.getElement('select').addEvent('change', function (el) {
			self._cur1_select.getElement('li.hidden').removeClass('hidden');
			self._cur1_select.getElements('li').each(function (_el) {
				if (el.get('value') == _el.getAttribute('data-value')) {
					_el.addClass('hidden');
				}
			});

			cur1 = self._cur1_select.getElement('.selected').getAttribute('data-value');

			self._currencies.each(function (_el) {
				if (_el.index == el.get('value') || _el.index == cur1) {
					_el.addClass('_selected');
				} else {
					_el.removeClass('_selected');
				}
			});

			currency2 = el.get('text');
			self.currency2 = currency2.substring(0, currency2.lastIndexOf(' '));
			self.currency_symbol2 = currency2.substring(currency2.lastIndexOf(' '), currency2.length);

			self._yaxis_title2.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency2 + (self.currency2.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');

			self.fireEvent('filter');
		});
	},

	get_data: function get_data() {
		var self = this;
		var currency = '';

		this._veil.show();

		if (!this.data || !this.data[this.type_id] || !this.data[this.type_id][this.pricetype_id] || !this.data[this.type_id][this.pricetype_id][this.region_id] || !this.data[this.type_id][this.pricetype_id][this.region_id][this.beds_id]) {

			this._currencies.each(function (_el) {
				if (_el.hasClass('_selected')) {
					var obj;
					try {
						obj = JSONMOO.decode('{"' + _el.index + '": "waiting"}', false);
					} catch (e) {}

					self.store_data(obj, self.type_id, self.pricetype_id, self.region_id, self.beds_id);
					currency += '&currency[]=' + _el.index.toUpperCase();
				}
			});
		} else {
			this._currencies.each(function (_el) {
				if (_el.hasClass('_selected') && !self.data[self.type_id][self.pricetype_id][self.region_id][self.beds_id][_el.index]) {
					self.store_data(JSONMOO.decode('{"' + _el.index + '": "waiting"}', false), self.type_id, self.pricetype_id, self.region_id, self.beds_id);
					currency += '&currency[]=' + _el.index.toUpperCase();
				}
			});
		}

		if (currency == '') {
			this.display_chart();
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?type=' + this.type_id + '&show=' + this.pricetype_id + '&region=' + this.region_id + '&bedrooms=' + this.beds_id + currency;

			var aptype = this.type_id,
			    pricetype = this.pricetype_id,
			    region = this.region_id,
			    beds = this.beds_id;

			new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), aptype, pricetype, region, beds);

					self.display_chart();
				}
			});
		}
	},

	store_data: function store_data(data, aptype, pricetype, region, beds) {
		var self = this;

		if (!this.data[aptype]) this.data[aptype] = {};
		if (!this.data[aptype][pricetype]) this.data[aptype][pricetype] = {};
		if (!this.data[aptype][pricetype][region]) this.data[aptype][pricetype][region] = {};
		if (!this.data[aptype][pricetype][region][beds]) this.data[aptype][pricetype][region][beds] = {};

		Object.each(data, function (el, i) {
			self.data[aptype][pricetype][region][beds][i] = el;
		});
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		if (this.chart) {
			this.chart.destroy();
		}

		this._currencies.each(function (_el) {
			if (_el.hasClass('_selected')) {
				if (_el.index == self.first_currency) {
					series[0] = {
						name: _el.index,
						data: self.data[self.type_id][self.pricetype_id][self.region_id][self.beds_id][_el.index],
						color: self.options.colors[0],
						yAxis: 0
					};
				} else {
					series[1] = {
						name: _el.index,
						data: self.data[self.type_id][self.pricetype_id][self.region_id][self.beds_id][_el.index],
						color: self.options.colors[1],
						yAxis: 1
					};
				}
			}
		});

		this.move_rangeselector();

		var min = null,
		    max = null;
		var second_grid_width = 1;

		if (self._cur1_select.getElement(':selected').get('value').toLowerCase() == 'usd' && self._cur2_select.getElement(':selected').get('value').toLowerCase() == 'u03' || self._cur1_select.getElement(':selected').get('value').toLowerCase() == 'u03' && self._cur2_select.getElement(':selected').get('value').toLowerCase() == 'usd') {

			series[0].data.each(function (el) {
				if (!min || min > el[1]) {
					min = el[1];
				}

				if (!max || max < el[1]) {
					max = el[1];
				}
			});

			series[1].data.each(function (el) {
				if (!min || min > el[1]) {
					min = el[1];
				}

				if (!max || max < el[1]) {
					max = el[1];
				}
			});

			second_grid_width = 0;
		}

		this.chart = new Highcharts.StockChart({
			chart: {
				renderTo: self._graph_cont,
				type: 'spline',
				backgroundColor: '#ebebeb',
				marginTop: 25
			},

			series: series,

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				selected: 5,
				inputEnabled: false,

				labelStyle: {
					color: '#666'
				},

				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				},

				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}]
			},

			credits: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: [{
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					style: {
						color: '#666'
					},
					y: -5,
					x: 0,
					formatter: function formatter() {
						var currency_code = self._cur1_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol1;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol1;
						}

						return self.currency_symbol1 + Core.add_commas(this.value);
					}
				},

				gridLineWidth: 1,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				showLastLabel: true,
				opposite: false
			}, {
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					style: {
						color: '#666'
					},
					y: -5,
					formatter: function formatter() {
						var currency_code = self._cur2_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol2;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol2;
						}

						return self.currency_symbol2 + Core.add_commas(this.value);
					}
				},

				// gridLineDashStyle: 'dash',
				endOnTick: false,
				showLastLabel: true,
				opposite: true,
				gridLineWidth: second_grid_width,
				gridLineColor: '#ccc'
			}],

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 100,
					type: 'datetime',
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					},
					gridLineColor: '#888',
					gridZIndex: 4
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					animation: true
				},

				// line: {
				//	 lineWidth: 3,

				//	 states: {
				//		 hover: {
				//			 lineWidth: 3
				//		 }
				//	 },

				//	 marker: {
				//		 enabled: false,
				//		 states: {
				//			 hover: {
				//				 enabled: false
				//			 }
				//		 }
				//	 },

				//	 dataGrouping: {
				//		 // groupPixelWidth: 5,
				//		 approximation: 'open',
				//		 // forced: true,
				//		 dateTimeLabelFormats: {
				//			 day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
				//			 week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
				//		 }
				//	 }
				// },

				spline: {
					lineWidth: 3,

					states: {
						hover: {
							lineWidth: 3
						}
					},

					marker: {
						enabled: false
					},

					dataGrouping: {
						groupPixelWidth: 10,
						approximation: 'open',
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			tooltip: {
				useHTML: true,
				valueDecimals: 0,
				shared: true,
				crosshairs: false,
				borderWidth: 2,
				borderColor: '#999',

				formatter: function formatter() {
					return self.get_tooltip(this);
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		});

		this._veil.hide();
	},

	get_tooltip: function get_tooltip(obj) {
		var self = this;

		var details, c_price1, h_price1, c_price2, h_price2;

		var current1 = obj.points[0].series.yData[obj.points[0].series.yData.length - 1];
		var current2 = obj.points[1].series.yData[obj.points[1].series.yData.length - 1];

		var result1 = ((current1 - obj.points[0].y) / obj.points[0].y * 100).round(1);
		var result2 = ((current2 - obj.points[1].y) / obj.points[1].y * 100).round(1);

		var current_date = new Date();
		var fromDate = new Date(Highcharts.dateFormat('%b %e, %Y', obj.points[0].x));
		var xy = self.date_difference(fromDate, current_date);

		if (self._cur1_select.getElement(':selected').get('value') == 'XAU') {
			c_price1 = Core.add_commas(current1.toFixed(1)) + ' ' + self.currency_symbol1;
			h_price1 = Core.add_commas(obj.points[0].y.toFixed(1)) + ' ' + self.currency_symbol1;
		} else if (self._cur1_select.getElement(':selected').get('value') == 'RUB') {
			c_price1 = Core.add_commas(current1) + ' ' + self.currency_symbol1;
			h_price1 = Core.add_commas(obj.points[0].y) + ' ' + self.currency_symbol1;
		} else {
			c_price1 = self.currency_symbol1 + Core.add_commas(current1);
			h_price1 = self.currency_symbol1 + Core.add_commas(obj.points[0].y.round());
		}

		if (self._cur2_select.getElement(':selected').get('value') == 'XAU') {
			c_price2 = Core.add_commas(current2.toFixed(1)) + ' ' + self.currency_symbol2;
			h_price2 = Core.add_commas(obj.points[1].y.toFixed(1)) + ' ' + self.currency_symbol2;
		} else if (self._cur2_select.getElement(':selected').get('value') == 'RUB') {
			c_price2 = Core.add_commas(current2) + ' ' + self.currency_symbol2;
			h_price2 = Core.add_commas(obj.points[1].y) + ' ' + self.currency_symbol2;
		} else {
			c_price2 = self.currency_symbol2 + Core.add_commas(current2);
			h_price2 = self.currency_symbol2 + Core.add_commas(obj.points[1].y.round());
		}

		var sign1 = current1.round(1) >= obj.points[0].y.round(1) ? '+' : '';
		result1 = sign1 + result1.toString();

		var sign2 = current2.round(1) >= obj.points[1].y.round(1) ? '+' : '';
		result2 = sign2 + result2.toString();

		details = '<div class="tooltip">' + '<div class="series_name" style="background-color:' + self.options.colors[0] + '">' + self.currency1 + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[0].x) + ': ' + '<b style="">' + h_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign1 == '+' ? 'green' : 'red') + '"/>' + result1.toString() + '%</span>' + '</div><br/>' + '<div class="series_name" style="background-color:' + self.options.colors[1] + '">' + self.currency2 + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[1].x) + ': ' + '<b style="">' + h_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign2 == '+' ? 'green' : 'red') + '"/>' + result2.toString() + '%</span>' + '</div>' + '</div>';

		return details;
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate, toDate;
		var year, month, day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft - 15,
				    topPosition = this.chart.plotTop,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 415,
					y: topPosition - 56

				});

				leftPosition += this.zoomText.getBBox().width + 420;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 70
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

var Tabscroll = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_tabscroll'
	},

	initialize: function initialize(_element, options) {
		this._element = document.id(_element);

		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var fcls = '.' + this.options.cls;
		var _element = document.id(this);

		this._tabs = _element.getElements(fcls + '_tabs li');
		this._content = _element.getElement(fcls + '_content');
		this._strip = _element.getElement(fcls + '_strip');
		this._items = _element.getElements(fcls + '_item');
		this.fx_items = [];

		this.active_index = 0;

		if (!this._items || this._items.length == 0) {
			this._element.dispose();
			return;
		}

		this.fx_scroll = new Fx.Scroll(this._content, {
			duration: 500,
			link: 'cancel'
		});

		this._tabs.each(function (_el, i) {
			_el.addEvent('click', this.select.bind(this, _el, i));

			if (this._tabs.length == 1) {
				_el.addClass('_full_width');
			} else if (i == 0) {
				_el.addClass('_first');
			} else if (i == this._items.length - 1) {
				_el.addClass('_last');
			}

			this.fx_items.push(new Fx.Morph(this._items[i], {
				duration: 1000,
				link: 'cancel'
			}));

			if (_el.hasClass('active') && i > 0 && this._items.length > 1) {
				this.select(_el, i);
			}
		}.bind(this));
	},

	select: function select(_tab, i, e) {
		if (e && e.stop) e.stop();

		if (this.active_index == i) return;

		this._tabs[this.active_index].removeClass('active');
		this.active_index = i;

		this._tabs[i].addClass('active');
		this.fx_scroll.toElement(this._items[i]);

		this.fx_items[i].start({
			opacity: [0, 1]
		});

		this.fireEvent('tabchange', i);
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

var Schools = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_schools',
		customId: 'schools'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) this.build();
	},

	build: function build() {
		var self = this;
		var rpc = this._element.get('data-rpc');

		if (rpc) {
			var remote = new Request.HTML({
				url: rpc,
				onSuccess: function onSuccess(a, b, c, d) {
					if (c === "") {
						self._element.getParent().dispose();
						return;
					}

					this.data = c;
					self._element.set('html', this.data);

					new Tabscroll(self.options.customId);

					var _shrinkers = self._element.getElements('.w_shrinker');

					_shrinkers.each(function (_shrinker) {
						var min_height = 270;

						new Shrinker(_shrinker, {
							min_height: min_height,
							toggler: _shrinker.getParent('.w_tabscroll_item').getElement('.w_shrinker_head'),
							single_opened: false,

							onShrink: function onShrink() {
								this._toggler.removeClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show more</span>');
							},

							onUnshrink: function onUnshrink() {
								this._toggler.addClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show less</span>');
							}
						});
					});
				},

				onFailure: function onFailure() {
					self._element.getParent().dispose();
				}
			});

			remote.get();
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var ColumnChart = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_columnchart',
		max_value: 0,
		increment: 100, //increment of the scale
		height: 500, //it's not a total height of the chart, it's height of it's scale
		disp_col: 5, //amount of displayed columns
		scroll_speed: 300,
		animate_values: true,
		scroll_at_a_time: 3, //how many items scroll at a time
		y_axis: '', //displayed name of y axis
		hscroll: true,
		zebra: true, //zebra background
		has_images: true,
		main_item_indicator: false, //horisontal dashed line
		scale_px_increment: 30,
		data: null,
		isBuilding: false,
		missingImage: null
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);
		this._element.addClass('_loading');

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (Core.is_ie8()) {
			this._element.addClass('ie');
		}

		this.max_value = opts.max_value;

		if (opts.y_axis != '') {
			this._y_axis = new Element('.y_axis', { 'html': '<div class="vertical_text">' + opts.y_axis + '</div>' }).inject(this._element);
		}

		this._chart = new Element('.chart').inject(this._element);

		if (opts.zebra) {
			this._zebra = new Element('.zebra').inject(this._chart);
		}

		this._scroller = new Element('.scroller').inject(this._chart);

		this._col_container = new Element('.col_container').inject(this._scroller);

		this.property = this._element.getProperty('data-property');
		this.y_axis_text = this._element.getProperty('data-yaxis-name');

		if (opts.data) {
			this.data = opts.data;
			this.process_rpc();
		} else {
			this.rpc_request();
		}

		this.add_functionalities();
	},

	add_hscroll: function add_hscroll() {
		var self = this;
		var opts = this.options;
		var _hscroll = this._hscroll = new Element('.hscroller', { 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._chart);

		this._element.addClass('_has_dragger');

		var _ar_l = this._ar_l = _hscroll.getElement('.ar_l');
		var _ar_r = this._ar_r = _hscroll.getElement('.ar_r');

		_ar_l.addEvent('click', function () {
			self._arr_prev.fireEvent('click');
		});

		_ar_r.addEvent('click', function () {
			self._arr_next.fireEvent('click');
		});

		var _dragger = this._dragger = _hscroll.getElement('.dragger'),
		    size_coefficient = this._items.length - opts.disp_col;

		this.dragger_fx = new Fx.Morph(_dragger, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.linear
		});

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = self.dragger_max_left = _hscroll.getSize().x - dr_size,
		    dragger_left = max_left / (this._items.length - opts.disp_col) * this.current_col;

		if (this.current_col == 0) {
			_ar_l.addClass('inactive');
		} else if (this.current_col == this.last) {
			_ar_r.addClass('inactive');
		}

		(function () {
			self.dragger_fx.start({ 'left': dragger_left });
			self.dragger_fx.setOptions({ duration: self.options.scroll_speed });
		}).bind(this).delay(2000);

		_hscroll.addEvents({
			'mouseenter': function mouseenter() {
				if (self.dragging != true) self._element.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) self._element.removeClass('dragging');
			}
		});

		_dragger.addEvent('mousedown', function (e) {
			self.dragging = true;
			self._element.addClass('dragging');
			dragger_left = _dragger.getStyle('left').toInt();
			self.init_pos = e.page.x;
			return false;
		});

		$(document.body).addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - self.init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var area = self.drag_area = (left / (max_left / (self._items.length - opts.disp_col))).round();

					self.animate.set(left * ((self._col_container.getSize().x - self.scr_width) / max_left), 0);

					if (self.current_col != area) {
						self.current_col = area;

						if (area == 0) {
							self._arr_prev.addClass('inactive');
							_ar_l.addClass('inactive');
						} else {
							self._arr_prev.removeClass('inactive');
							_ar_l.removeClass('inactive');
						}

						if (area == self._items.length - opts.disp_col) {
							self._arr_next.addClass('inactive');
							_ar_r.addClass('inactive');
						} else {
							self._arr_next.removeClass('inactive');
							_ar_r.removeClass('inactive');
						}
					}

					self.hide_locked_item();
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
				self._element.removeClass('dragging');
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				self._element.removeClass('dragging');
			}
		});
	},

	create_scale: function create_scale() {
		this._scale = new Element('.scale');

		if (this._y_axis) {
			this._scale.inject(this._y_axis, 'after');
		} else {
			this._scale.inject(this._element, 'top');
		}

		var increment = this.options.increment;

		// Force the max_value to be rounded to the nearest increment
		this.max_value = Math.ceil(this.max_value / increment) * increment;

		// Calculate the number of increments that can fit into the chart height
		var numIncrements = Math.floor(this.options.height / this.options.scale_px_increment);
		increment = Math.ceil(this.max_value / numIncrements);

		var value = 0,
		    _el;

		this._values = [];

		// Adjust grid height based on the new increment value
		var grid_height = this.options.height / numIncrements;

		while (value <= this.max_value) {
			var grid_char = this.options.zebra ? '&bull;' : '-';
			var formattedValue = '$' + Core.add_commas(value);
			_el = new Element('.value', {
				'html': formattedValue + '<div class="grid">' + grid_char + '</div>',
				'styles': {
					'height': grid_height + 'px'
				}
			}).inject(this._scale, 'top');
			value += increment;

			this._values.push(_el);
		}

		this.options.height = grid_height * this._values.length;

		if (this._zebra) {
			var cls = '';
			this._values.each(function (_el, i) {
				var zebra_height = grid_height;

				if (cls == '') {
					cls = 'x';
					zebra_height -= 2; //dashed border of the zebra
				} else {
					cls = '';
				}

				var _strip = new Element('div', { 'class': cls });
				_strip.inject(this._zebra);
				_strip.setStyle('height', zebra_height);
			}.bind(this));

			var margin = this._scale.getElement('.grid').getCoordinates().top - this._chart.getCoordinates().top - this._scale.getElement('.grid').getStyle('margin-top').toInt();
			this._zebra.getElement('div').setStyle('margin-top', margin);
		} else {
			this._values.each(function (_el) {
				_el.setStyle('height', grid_height);
			});
		}

		var scale_height = this._scale.getSize().y - this._scale.getStyle('padding-top').toInt() + this._scale.getElement('.grid').getStyle('top').toInt();
		this._scale.setStyle('height', scale_height);

		var grid_width = this._chart.getComputedSize().computedBottom;
		this._scroller.setStyle('height', this._scale.getSize().y - grid_width);

		if (this._y_axis) {
			this._y_axis.setStyle('height', this._scale.getSize().y - grid_width);
		}

		this.set_prices();
	},

	set_prices: function set_prices() {
		var height;
		var price;

		this._items.each(function (e) {
			price = e.getAttribute('data-price').toInt();
			height = (price * this.options.height / this.max_value).round() - 1;

			if (this.options.animate_values == true) {
				e.setAttribute('data-height', height);
			} else {
				e.setStyle('height', height);
			}

			if (e.hasClass('main') && this._indicator) {
				this._indicator.setStyle('bottom', height).addClass('visible');
			}
		}.bind(this));
	},

	rpc_request: function rpc_request() {
		var self = this;

		if (!self.options.data) {
			new Remote({
				rpc: this._element.getAttribute('data-rpc'),
				method: 'get',
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.process_rpc();

					document.fireEvent('columnChartLoaded');
				},
				onError: function onError() {
					this._element.set('html', 'Server connection error. Please try later');
				}
			});
		} else {
			self.process_rpc();
		}
	},

	process_rpc: function process_rpc() {
		this._items = [];
		var col_container_width = 0;

		if (this.data && this.data != '') {
			this.change_y_label();

			var notFoundImageUrls = ['/l/not-found-grey-gallery-1.png', '/l/not-found-grey-gallery-2.png', '/l/not-found-grey-gallery-3.png', '/l/not-found-grey-gallery-4.png', '/l/not-found-grey-gallery-5.png', '/l/not-found-grey-gallery-6.png', '/l/not-found-grey-gallery-7.png', '/l/not-found-grey-gallery-8.png'];
			var notFoundImageCnt = 0;

			this.data.each(function (e, i) {

				if (!e.thumbor_images || !!e.thumbor_images && e.thumbor_images.length == 0) {
					var _index = notFoundImageCnt % 8;
					e.notFoundImageUrl = Res_i + notFoundImageUrls[_index];
					notFoundImageCnt++;
				}

				var price = e[this.property];

				price = price.toInt();

				if (this.max_value < price) {
					this.max_value = price;
				}

				var img_path,
				    name = (e.name || e.address || e.building_name || e.building_address) + (e.unit ? ', #' + e.unit : ''),
				    cls = 'bld_item' + (e.current == true ? ' main' : ''),
				    html = '';

				if (e.current == true && this.options.main_item_indicator) {
					this._indicator = new Element('.indicator', { 'html': '<div class="pointer">&nbsp;</div>' }).inject(this._chart).fade('hide');
				}

				if (this.options.has_images) {
					img_path = this.options.tmp_img || e.image;

					html = '<img src="' + img_path + '"' + 'onerror="' + this.options.err_img + '"' + '/>';
				}
				var vt_html = '<div class="vt_container">' + '<div class="vertical_text">' + name + '</div>' + '</div>';

				var add_cls = this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page' ? '' : ' w_blimp_bld';

				var _bld_item = new Element('div', {
					'class': cls + add_cls,
					'html': html,
					'data-price': e[this.property],
					'data-class': 'w_blimp_bld'
				});

				this._items.push(_bld_item);

				_bld_item.addEvents({
					'mouseenter': function () {
						if (this.locked_item) {
							this.locked_item.removeClass('_active');
						}

						this.locked_item = _bld_item;
						this.locked_item.addClass('_active');
						this.bulb_show(e, _bld_item);
					}.bind(this)
				});

				// if(e.url_listing || e.url && e.url != ''){
				// 	_bld_item.set('data-rpc', e.url_listing || e.url);

				// 	if (this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page'){
				// 		_bld_item.addEvent('click', function(){ window.location = e.url_listing || e.url; });
				// 	}else{
				// 		new BlimpExt(_bld_item, {
				// 			draggable: true,
				// 			show_veil: true,
				// 			onPostRpc: function(){
				// 				new BldBlimp(this);
				// 			}
				// 		});
				// 	}
				// }

				var _column = new Element('div', {
					'class': 'column' + (i == this.data.length - 1 ? ' last' : ''),
					'html': vt_html
				}).adopt(_bld_item).inject(this._col_container);

				var col_w = _column.getComputedSize().width,
				    col_m = _column.getStyle('margin-right').toInt();

				col_container_width += col_w + col_m;

				if (!this.scroll_w_is_set) {
					this.set_scroll_width(col_w, col_m);
					this.scroll_w_is_set = true;
				}
			}.bind(this));

			(function () {
				this._col_container.setStyle('width', col_container_width);
			}).delay(500, this);

			this._main_col = this._scroller.getElement('.main');

			if (this._main_col) {
				this._init_scroll = this._main_col.getParent('.column');
			} else {
				//this.fireEvent('notEnoughData');
			}

			this.create_scale();

			if (this._scroller.getStyle('width').toInt() < col_container_width) {
				this.add_scrolling();
			}

			if (this.options.animate_values == true) {
				this.animate_prices();
			} else {
				if (this._indicator && this._indicator.hasClass('visible')) {
					this._indicator.fade('show');
				}
			}

			this._bulb = new Element('.' + this.options.cls + '_bulb', {
				'html': '<div class="pointer">&nbsp;</div>'
			}).inject(this._element);

			this._bulb.addClass('clearfix');

			if (!this.options.isBuilding) {
				this._bulb.addClass('_listings');
			} else {
				this._bulb.addClass('_buildings');
				this._info = new Element('div.info').inject(this._bulb, 'top');

				var content = this._info;
				this._bulb_name = new Element('a.name').inject(content);
				this._bulb_address = new Element('a.address').inject(content);
				this._bulb_details = new Element('span.details').inject(content);
				this._bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
				this._bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
				this._bulb_size = new Element('span.size').inject(content);
				this._bulb_created = new Element('span.created').inject(content);
				this._bulb_updated = new Element('span.updated').inject(content);
				var grey_box = new Element('div.grey-box').inject(content);
				this._bulb_price = new Element('span.price').inject(grey_box);
				this._bulb_sales = new Element('span.sales').inject(grey_box);
			}

			this._chart.setStyle('visibility', 'visible');

			if (this._y_axis) {
				this._y_axis.setStyle('visibility', 'visible');
			}
		} else {
			this.fireEvent('noData');
		}

		this._element.removeClass('_loading');
	},

	change_y_label: function change_y_label() {
		if (!this._y_axis) return;

		this._y_axis.getElement('.vertical_text').set('html', this.y_axis_text);
	},

	set_scroll_width: function set_scroll_width(w, m) {
		var dc = this.options.disp_col,
		    width = this.scr_width = w * dc + m * (dc - 1) - 100;

		this._scroller.setStyle('width', width);
	},

	bulb_show: function bulb_show(data, _el) {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		if (this.bubble_is_ready && this.dragging != true) {
			if (!this.options.isBuilding) {
				this.add_listing_tile(data);
			} else {

				var add_text = this.property == 'ppsqft' || this.property == 'sqft' ? ' /ft<sup>2</sup>' : '';
				var price = data[this.property];

				var transactions = data.transactions || 0;
				var str_sales = transactions > 1 ? 'sales' : 'sale';

				this._bulb_sales.set('html', 'Based on ' + transactions + ' ' + str_sales + '<br/>in past 12 months');

				if (data.sale && data.sale.available > 0) {
					var apts = data.sale.available > 1 ? ' Apartments' : ' Apartment';
					if (data.sale.min == data.sale.max) {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> for $' + Core.short_number(data.sale.min));
					} else {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> ($' + Core.short_number(data.sale.min) + ' - $' + Core.short_number(data.sale.max) + ')');
					}
					this._bulb_available_for_sale.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'sale');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_sale.set('html', '');
				}

				if (data.rent && data.rent.available > 0) {
					var apts = data.rent.available > 1 ? ' Apartments' : ' Apartment';
					if (data.rent.min == data.rent.max) {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> for $' + Core.add_commas(data.rent.min));
					} else {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> ($' + Core.add_commas(data.rent.min) + ' - $' + Core.add_commas(data.rent.max) + ')');
					}
					this._bulb_available_for_rent.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'rent');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_rent.set('html', '');
				}

				this._bulb_price.set('html', '$' + Core.add_commas(price) + add_text);
				this._bulb_name.set('text', (data.name || data.address || data.building_name || data.building_address) + (data.unit ? ', #' + data.unit : ''));
				this._bulb_name.set('href', data.url_listing || data.url || data.building_url);

				if (data.sqft) {
					this._bulb_size.set('html', 'Approx. ' + data.sqft + ' ft<sup>2</sup>');
				}
				// if (data.listing_added) {
				// 	this._bulb_created.set('text', 'Listed ' + data.listing_added);
				// }
				// if (data.listing_updated) {
				// 	this._bulb_updated.set('text', 'Updated ' + data.listing_updated);
				// }

				if (data.name || data.building_name) {
					if (data.address || data.building_address) {
						this._bulb_address.set('text', data.address || data.building_address);
					}
					if (data.url || data.building_url) {
						this._bulb_address.set('href', data.url_listing || data.url || data.building_url);
					}
					this._bulb_address.show();
				} else {
					this._bulb_address.hide();
				}

				if (this.options.isBuilding) {
					this._bulb.set('data-class', 'w_blimp_bld');
					this._bulb.set('href', data.url);

					new BlimpExt(this._bulb, {
						draggable: true,
						show_veil: true,
						onPostRpc: function onPostRpc() {
							new BldBlimp(this);
						}
					});
				}

				if (this._bulb_ppsqft && data["ppsqft"] != null) {
					this._bulb_ppsqft.set('html', '$' + Core.add_commas(data["ppsqft"]) + ' /ft<sup>2</sup>');
				} else {
					if (this._bulb_ppsqft) {
						this._bulb_ppsqft.setStyle('display', 'none');
					}
				}

				this._bulb_details.set('text', data.beds_baths);
				this.add_save_support(data);
			}

			var v_pos = _el.getStyle('height').toInt() + this._bulb.getElement('.pointer').getStyle('height').toInt() + this._element.getComputedSize().computedBottom + 1 /*border*/
			,
			    h_pos = _el.getCoordinates().left - this._element.getCoordinates().left - this._bulb.getStyle('width').toInt() / 2 - this._bulb.getStyle('padding-left').toInt() + _el.getCoordinates().width / 2;

			this._bulb.setStyles({
				'bottom': v_pos,
				'left': h_pos > 400 ? h_pos - 160 : h_pos + 160
			});
			if (h_pos > 400) {
				this._bulb.addClass('right-bulb');
			} else {
				this._bulb.removeClass('right-bulb');
			}

			this._bulb.show();
		}
	},

	add_listing_tile: function add_listing_tile(data) {
		// for listings
		if (!this.options.isBuilding) {
			if (this.listingTile) {
				// dont do anything if the user mouseover to the last active listing again
				if (this.listingTile.hasClass('_' + data.mask_id)) {
					return;
				}

				// remove the current save button
				this.listingTile.dispose();
			}

			if (data.listingTile) {
				data.listingTile.inject(this._bulb);
			} else {
				data.contact = '';
				data.listingTile = new Element('<cr-listing-tile', {
					'class': 'cr-listing-tile' + ' _' + data.mask_id,
					'data-rpc': data.url_v2,
					'data-open-blimp-on-click': true,
					'data-missing-image': this.options.missingImage,
					'data-rpc-save-to-profile': this.options.rpcSaveToProfile,
					'html': '<div class="hidden none obj-wrapper">' + JSONMOO.encode(data) + '</div>'
				}).inject(this._bulb);

				Core.compile_html(data.listingTile);
			}

			this.listingTile = data.listingTile;
		}
	},

	add_save_support: function add_save_support(data) {
		if (this.currentSaveButton) {
			var id = this.options.isBuilding ? data.building_id : data.mask_id;
			// dont do anything if the user mouseover to the last active listing again
			if (this.currentSaveButton.hasClass('_' + id)) {
				return;
			}
			// remove the current save button
			this.currentSaveButton.dispose();
		}

		this.currentSaveButton = data.crSaveToProfile;
	},

	bulb_hide: function bulb_hide() {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		this._bulb.hide();
	},

	add_scrolling: function add_scrolling() {
		this._arr_prev = new Element('.arr_prev');
		this._arr_next = new Element('.arr_next');

		this._columns = this._scroller.getElements('.column');
		this.current_col = 0;

		this._arr_prev.inject(this._chart);
		this._arr_next.inject(this._chart);

		this.animate = new Fx.Scroll(this._scroller, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.Quad.easeOut,
			onStart: function () {
				this.hide_locked_item();
			}.bind(this)
		});

		if (this._init_scroll) {
			this._columns.each(function (_el, i) {
				if (_el === this._init_scroll) {
					var half = Math.ceil(this.options.disp_col / 2);

					if (i < half) {
						this.current_col = 0;
						this._arr_prev.addClass('inactive');
					} else if (this._columns.length - i <= half) {
						this.current_col = this._columns.length - this.options.disp_col;
						this._arr_next.addClass('inactive');
					} else {
						this.current_col = i - half + 1;
					}
				}
			}.bind(this));
		} else {
			this._arr_prev.addClass('inactive');
			this.current_col = 0;
		}

		(function () {
			this.animate.toElement(this._columns[this.current_col]).chain(function () {
				this._arr_prev.addEvent('click', this.scroll_prev.bind(this));
				this._arr_next.addEvent('click', this.scroll_next.bind(this));
			}.bind(this));
			this.animate.setOptions({ duration: this.options.scroll_speed });
		}).bind(this).delay(2000);

		this.last = this._columns.length - this.options.disp_col;

		if (this.options.hscroll == true) {
			this.add_hscroll();
		}
	},

	animate_prices: function animate_prices() {
		if (!this.current_col) this.current_col = 0;

		var last_visible = Math.min(this.current_col + this.options.disp_col - 1, this._items.length - 1);
		var speed = 2000;

		this._items.each(function (_el, i) {
			var height = _el.getAttribute('data-height');

			if (i >= this.current_col && i <= last_visible) {
				var sc = speed * _el.getAttribute('data-price').toInt() / this.max_value,
				    //speed coefficient
				delay = (i >= this.current_col ? i - this.current_col : 0) * 100 + 100;

				(function () {
					var tween = new Fx.Morph(_el, { duration: sc, transition: Fx.Transitions.Bounce.easeOut });
					tween.start({ 'height': [0, height] });
				}).delay(delay);
			} else {
				(function () {
					_el.setStyle('height', height.toInt());
				}).delay(500);
			}
		}.bind(this));

		(function () {
			this.bubble_is_ready = true;

			if (this._indicator && this._indicator.hasClass('visible')) {
				this._indicator.fade('in');
			}
		}).bind(this).delay(speed);
	},

	scroll_prev: function scroll_prev() {
		var prev = this.current_col - this.options.scroll_at_a_time;

		if (prev > 0) {
			this.animate.toElement(this._columns[prev]);
			this.current_col -= this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[0]);
			this._arr_prev.addClass('inactive');
			this._ar_l.addClass('inactive');
			this.current_col = 0;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_next.removeClass('inactive');
		if (this._ar_r) {
			this._ar_r.removeClass('inactive');
		}
	},

	scroll_next: function scroll_next() {
		var next = this.current_col + this.options.scroll_at_a_time;

		if (next < this.last) {
			this.animate.toElement(this._columns[next]);
			this.current_col += this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[this.last]);
			this._arr_next.addClass('inactive');
			this._ar_r.addClass('inactive');
			this.current_col = this.last;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_prev.removeClass('inactive');
		if (this._ar_l) {
			this._ar_l.removeClass('inactive');
		}
	},

	add_functionalities: function add_functionalities() {
		var self = this;
		this._element.addEvents({
			'mouseenter': function mouseenter() {
				self._element.addClass('_hover');
			},
			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');
				self.hide_locked_item();
			}
		});
	},

	hide_locked_item: function hide_locked_item() {
		if (this.locked_item) {
			this.bulb_hide();
			this.locked_item.removeClass('_active');
		}
	}
});
'use strict';

Page.Mid = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		var _graph = document.getElement('.city_stats');

		if (!_graph) return;

		this.add_city_stats(_graph);
	},

	add_city_stats: function add_city_stats(_cont) {
		var self = this;
		var _city_stats = _cont;

		if (!_city_stats) return;

		var _graphs = _city_stats.getElements('.w_graph');
		var _graph_categories = _city_stats.getElement('.w_graph_categories');
		var _graph_categories_options = _graph_categories.getElements('.btn_option');
		var _active_city_stats_graph = _graphs[0];

		if (_graph_categories_options.length > 0) {
			_graph_categories_options.each(function (_option, i) {
				if (i != 0) {
					_graphs[i].hide();
				}

				_option.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					if (_active_city_stats_graph) _active_city_stats_graph.hide();

					if (_graph_categories_options) _graph_categories_options.removeClass('selected');

					_active_city_stats_graph = _graphs[i];
					_graph_categories_options = _option;
					_option.addClass('selected');

					if (!_option.initialized_graph) {
						_option.graph = self['run_citystats_' + _option.get('data-graph')](_active_city_stats_graph);
						_option.initialized_graph = true;
					}

					_active_city_stats_graph.show();
					_graph_categories.inject(_active_city_stats_graph.getElement('.w_graph_footer'), 'top');
				});
			});
		}

		var index = 0;
		if (location.hash) {
			var hash = location.hash.replace('#', '');

			if (hash.indexOf('/') > -1) {
				hash = hash.replace('/', '');
			}

			if (hash == 'building-comparison') {
				index = 3;
			} else if (hash == 'new-developments') {
				index = 4;
			}
		}

		_graph_categories_options[index].fireEvent('click');

		this.set_message(_city_stats);
	},

	run_citystats_apartment_prices: function run_citystats_apartment_prices(_cont) {
		var self = this;

		return new Page.Mid.MIAP(_cont, {
			onMakeStat: function onMakeStat(data) {
				var _type_select = document.getElement('.neighborhood_stats .w_styled_select._type select');
				var _region_selector = document.id('region_selector');

				if (_region_selector) _region_selector.dispose();

				self.make_stat(data, _type_select);
			}
		});
	},

	run_citystats_currency_comparison: function run_citystats_currency_comparison(_cont) {
		return new MICC(_cont);
	},

	run_citystats_condo_vs_coop_comparison: function run_citystats_condo_vs_coop_comparison(_cont) {
		return new MICP(_cont, {
			'onShow_in_apartment_prices': function onShow_in_apartment_prices(region_id, type_id, beds_id, pricetype_id, currency_id) {
				var _apartment_prices_option = document.getElement('.city_stats .w_graph_categories .apartment_prices');
				var _self_MIAP = _apartment_prices_option.graph;
				var filter_changed = false;

				var _beds_options = _self_MIAP._beds_select_options;
				var _type_options = _self_MIAP._type_select_options;
				var _pricetype_options = _self_MIAP._pricetype_select_options;
				var _currency_options = _self_MIAP._currency_select_options;

				if (_self_MIAP.beds_id != beds_id) {
					_beds_options.each(function (_option, i) {
						if (_option.get('value') == beds_id) {
							_self_MIAP._beds_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (_self_MIAP.type_id != type_id) {
					_type_options.each(function (_option, i) {
						if (_option.get('value') == type_id) {
							_self_MIAP._type_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (_self_MIAP.pricetype_id != pricetype_id) {
					_pricetype_options.each(function (_option, i) {
						if (_option.get('value') == pricetype_id) {
							_self_MIAP._pricetype_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (_self_MIAP.curr_id != currency_id) {
					_currency_options.each(function (_option, i) {
						if (_option.get('value') == currency_id) {
							_self_MIAP._currency_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (!_self_MIAP.selected_region && region_id != 0 || _self_MIAP.selected_region && _self_MIAP.selected_region.toInt() != region_id) {
					filter_changed = true;
				}

				if (!filter_changed) return;

				if ((!_self_MIAP.selected_region || _self_MIAP.selected_region != '0') && region_id != 0) {
					_self_MIAP.show_by_region(region_id);
				} else {
					if (region_id == 0 && _self_MIAP._back_button) {
						_self_MIAP._back_button.fireEvent('click');
					}
				}
			}
		});
	},

	run_citystats_new_developments: function run_citystats_new_developments(_cont) {
		this.run_citystats_building_comparison(_cont);
	},

	run_citystats_building_comparison: function run_citystats_building_comparison(_cont) {
		var mibc = new MIBC(_cont, {
			'onSet_cookie': function onSet_cookie() {
				var self = this;
				var my_cookie = [];
				var unselected_regions = [];

				self._beds_options.each(function (_li, i) {
					if (_li.hasClass('selected')) {
						my_cookie.push(i);
					}
				});

				self._pricetype_options.each(function (_li, i) {
					if (_li.hasClass('selected')) {
						my_cookie.push(i);
					}
				});

				self._currency_options.each(function (_li, i) {
					if (_li.hasClass('selected')) {
						my_cookie.push(i);
					}
				});

				my_cookie.push(this.type_id);

				self._regions.each(function (_li, i) {
					if (!_li.hasClass('_selected')) {
						unselected_regions.push(i);
					}
				});

				my_cookie.push(unselected_regions);

				Cookie.write('mbc_previous_filter', JSONMOO.encode(my_cookie));
			},

			'onApply_previous_filter': function onApply_previous_filter() {
				var self = this;
				var previous_filter = JSONMOO.decode(Cookie.read('mbc_previous_filter'), false);

				if (!previous_filter) return;

				self.previous_active_region = previous_filter[4];

				if (!previous_filter[0] == 0) {
					self._beds_options[previous_filter[0]].fireEvent('click');
				}

				if (!previous_filter[1] == 0) {
					self._pricetype_options[previous_filter[1]].fireEvent('click');
				}

				if (!previous_filter[2] == 0) {
					self._currency_options[previous_filter[2]].fireEvent('click');
				}

				if (previous_filter[3] != '2') {
					toggle._toggles[1].fireEvent('click');
				}
			},

			'onSet_active_regions': function onSet_active_regions() {
				var self = this;

				if (self.previous_active_region && self.previous_active_region.length != 0) {
					self.previous_active_region.each(function (el) {
						self._regions[el].fireEvent('click');
					});

					self.previous_active_region.empty();
				}
			}
		});

		return mibc;
	},

	make_stat: function make_stat(data, _type_select) {
		var _controllers = document.getElement('.neighborhood_stats .graph_controllers');
		var _cat = document.getElement('.neighborhood_stats .nh_categories');
		var nh_id, region_Id;

		if (data) {
			nh_id = data.id;
			region_Id = data.regionId;
		}

		var nh_stats = new NhStats(_controllers, {
			type: _type_select.getElement(':selected') || _type_select.getElement(':selected').getAttribute('value'),

			onNhSet: function onNhSet(_styled_select) {
				this.current_nh_id = nh_id;
			}
		});

		var _r = _cat.getElement('[data-region=' + region_Id + ']');
		if (_r) {
			_r.fireEvent('click');
		}

		var _summary_title = document.getElement('.w_neighborhoods ._type');

		_type_select.addEvent('change', function (_el) {
			nh_stats.type = _el.getAttribute('value');

			if (_summary_title) {
				var str = nh_stats.type == 3 ? 'Co-op Sales Summary' : 'Condo Sales Summary';
				_summary_title.set('html', str);
			}

			if (nh_stats._clicked_cat) {
				nh_stats._clicked_cat.fireEvent('click');
			}
		});
	},

	set_message: function set_message(_section) {
		var position = _section.getPosition();
		this._message = _section.getElement('.message');

		if (position.x < this._message.getSize().x) {
			this._message.addClass('on_top');
		}

		this._message.fade('in');
		(function () {
			this._message.fade('out');
		}).delay(10000, this);
	}
});
Page.Mid.MIAP = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00', '#a4b700', '#008ad9', '#b901fd', '#484a67', '#fa9a02', '#e20101', '#00c09e', '#139d05', '#010fca', '#672466', '#fe7a7a', '#a87b01', '#fb94fa', '#0ef619', '#febbbb', '#f6d80e', '#654e77', '#243eff', '#615715', '#24ffed'],

		selected_hoods: [4, 8, 9, //East Side
		10, 11, 14, //West Side
		21, 24, 32, //Downtown
		5, 6, 15, //Midtown
		215, 237, 1200, //Brooklyn
		20, 27],

		unselected_item_color: '#aaa'
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');
		this._warning = this._element.getElement('.warning');
		this._veil = this._element.getElement('.veil');
		this._graph_legends = this._element.getElement('.w_graph_legends');

		this._beds_li_options = this._element.getElements('.w_styled_select._beds li.option');
		this._type_li_options = this._element.getElements('.w_styled_select._type li.option');
		this._pricetype_li_options = this._element.getElements('.w_styled_select._price_types li.option');
		this._currency_li_options = this._element.getElements('.w_styled_select._currencies li.option');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._type_select = this._element.getElement('.w_styled_select._type select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		this._beds_select_options = this._beds_select.getElements('option');
		this._type_select_options = this._type_select.getElements('option');
		this._pricetype_select_options = this._pricetype_select.getElements('option');
		this._currency_select_options = this._currency_select.getElements('option');

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.type_id = this._type_select.getElement(':selected').get('value');
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.curr_id = this._currency_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');

		this.data_changed = true;

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		this._type_select.addEvent('change', function () {
			self.type_id = self._type_select.getElement(':selected').get('value');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		var currency = this._currency_select.getElement(':selected').get('text');
		this.currency = currency.substring(0, currency.lastIndexOf(' '));
		this.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

		this._currency_select.addEvent('change', function () {
			self.curr_id = self._currency_select.getElement(':selected').get('value');
			self.data_changed = true;

			var currency = self._currency_select.getElement(':selected').get('text');
			self.currency = currency.substring(0, currency.lastIndexOf(' '));
			self.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		this.regions_data = JSONMOO.decode(document.getElement('.hoods_data').get('html'), false);

		this.build_legends();

		this.fireEvent('filter');

		if (this._element.get('data-filter-from')) {
			this.update_filter();
		}
	},

	build_legends: function build_legends() {
		var self = this;

		if (this.selected_region) {
			var _regions = this._element.getElement('.regions');

			if (!this.region_legends) {
				this.region_legends = _regions.get('html'); // holds the legend of the regions
			}

			_regions.set('html', '');

			self._graph_legends.setAttribute('data-area', 'hood');

			this.regions_data.each(function (data) {
				if (data.id == self.selected_region.toInt()) {
					self.selected_region_name = data.name;

					Object.each(data.hoods, function (hood, i) {

						new Element('li', {
							'class': 'region_' + i + (self.options.selected_hoods.contains(i.toInt()) ? ' _selected' : ''),
							'data-id': i,
							'html': '<span class="spline"></span><span>' + hood + '</span>'
						}).inject(_regions);
					});
				}
			});

			if (!this._back_button) {
				this._back_button = new Element('span', {
					'class': 'back_to_regions',
					'html': 'back to regions'
				}).inject(this._graph_legends);

				this._back_button.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					self._graph_legends.setAttribute('data-area', 'region');

					self.selected_region = null;
					self.selected_region_name = '';
					self.build_legends();
					self.rebuild_chart();
					self.update_header();
				});
			} else {
				this._back_button.show();
			}

			var _key_title = this._element.getElement('.key_title');
			if (_key_title) _key_title.set('text', this.selected_region_name + ' Neighborhoods');
		} else {
			if (this.region_legends) {
				var _regions = this._element.getElement('.regions');
				_regions.set('html', this.region_legends);
			}

			if (this._back_button) this._back_button.hide();

			var _key_title = this._element.getElement('.key_title');
			if (_key_title) _key_title.set('text', 'Regions');
		}

		this._regions = this._element.getElements('.regions li');

		this.regions = {};

		this._regions.each(function (_el, i) {
			_el.index = _el.get('data-id');
			self.regions[_el.index] = _el.get('text').trim();

			var color = self.options.colors[i];
			self.colors.push(color);
			_el.color = color;

			if (_el.hasClass('_selected')) {
				_el.getElement('.spline').setStyle('background-color', color);
			} else {
				_el.getElement('.spline').setStyle('background-color', self.options.unselected_item_color);
			}

			var config;

			try {
				config = JSONMOO.decode(_el.getElement('.hoods').get('html'), false);
			} catch (e) {}

			if (typeOf(config) == 'object') {
				_el.hoods = config;
			}

			_el.addEvents({
				'click': function click() {
					if (!self.chart) {
						return;
					}

					_el.toggleClass('_selected');

					if (_el.hasClass('_selected')) {
						self.region_id = _el.index;
						_el.getElement('.spline').setStyle('background-color', _el.color);

						if (self.data_changed) {
							self.fireEvent('filter');
						} else {
							self.add_serie(_el.index);
						}
					} else {
						self.remove_serie(_el.index);
						_el.getElement('.spline').setStyle('background-color', self.options.unselected_item_color);
					}
				}
			});
		});

		this.update_legend_title();

		if (this.selected_region) {
			this.rebuild_chart();
		}
	},

	update_legend_title: function update_legend_title() {
		if (!this._key_title) {
			this._key_title = this._element.getElement('.key_title');
		}

		var title = this.selected_region_name ? this.selected_region_name + ' Neighborhoods' : 'Regions';

		this._key_title.set('text', title);
	},

	get_data: function get_data() {
		var self = this;
		var region = '';

		this._veil.show();

		this.area = this._element.getElement('.w_graph_legends').getAttribute('data-area');

		if (!this.data || !this.data[this.type_id] || !this.data[this.type_id][this.pricetype_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id][this.beds_id]) {

			this._regions.each(function (_el) {
				if (_el.hasClass('_selected')) {
					var obj;
					try {
						obj = JSONMOO.decode('{"' + _el.index + '": "waiting"}', false);
					} catch (e) {}

					self.store_data(obj, self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		} else {
			this._regions.each(function (_el) {
				if (_el.hasClass('_selected') && !self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index]) {
					self.store_data(JSONMOO.decode('{"' + _el.index + '": "waiting"}', false), self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		}

		if (region == '') {
			this.display_chart();
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?area=' + this.area + '&type=' + this.type_id + '&show=' + this.pricetype_id + '&currency=' + this.curr_id + '&bedrooms=' + this.beds_id + region;

			var aptype = this.type_id,
			    pricetype = this.pricetype_id,
			    region = this.curr_id,
			    beds = this.beds_id;

			// if(this.remote){
			// 	this.remote.cancel();
			// 	this.running_rpcs--;
			// }

			this.remote = new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), aptype, pricetype, region, beds);

					self.display_chart();
				}
			});
		}
	},

	store_data: function store_data(data, aptype, pricetype, currency, beds) {
		var self = this;

		if (!this.data[aptype]) this.data[aptype] = {};
		if (!this.data[aptype][pricetype]) this.data[aptype][pricetype] = {};
		if (!this.data[aptype][pricetype][currency]) this.data[aptype][pricetype][currency] = {};
		if (!this.data[aptype][pricetype][currency][beds]) this.data[aptype][pricetype][currency][beds] = {};

		Object.each(data, function (el, i) {
			self.data[aptype][pricetype][currency][beds][i] = el;
		});
	},

	update_header: function update_header() {
		var _header = this._element.getElement('.w_graph_header');
		var hood_name = this.selected_region_name ? ': ' + this.selected_region_name : '';

		_header.getElement('span').set('text', hood_name);
	},

	rebuild_chart: function rebuild_chart() {
		delete this.chart;

		this.fireEvent('filter');
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		this._regions.each(function (_el, i) {
			if (!self.data[self.type_id]) self.data[self.type_id] = {};
			if (!self.data[self.type_id][self.pricetype_id]) self.data[self.type_id][self.pricetype_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id]) self.data[self.type_id][self.pricetype_id][self.curr_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id]) self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id] = {};

			var data = self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index];

			if (_el.hasClass('_selected') && data && data != 'waiting' && data != []) {
				series.push({
					name: _el.index,
					data: data,
					color: _el.color,
					visible: _el.hasClass('_selected')
				});
			}
		});

		this.display_warning(series.length == 0);

		if (series.length == 0) {
			this._veil.hide();
			return;
		}

		if (this.chart) {
			this.chart.destroy();
		}

		this.move_rangeselector();

		this.get_rangedate();

		this.chart = new Highcharts.StockChart({
			chart: {
				renderTo: self._graph_cont,
				type: 'spline',
				backgroundColor: '#ebebeb',
				marginTop: 25
			},

			series: series,

			title: {
				useHTML: true,
				text: null, //(self.area == 'region')? 'ALL REGIONS' : '<a class="all_regions" href="' + self._element.getAttribute('data-url') + '?area=region' + '&type=' + self.type_id + '&show=' + self.pricetype_id + '&currency=' + self.curr_id + '&bedrooms=' + self.beds_id + '&date_from='+ self.min_date + '&date_to='+ self.max_date + '">ALL REGIONS</a> > ' + self._element.getAttribute('data-region-name'),
				x: 25,
				margin: 0,
				align: 'left',
				style: {
					color: '#ccc',
					font: '11px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif',
					fontWeight: 'bold'
				}
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				enabled: true,
				selected: 5,
				inputEnabled: true,

				inputPosition: {
					y: -200
				},

				labelStyle: {
					color: '#666'
				},

				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				},

				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}]
			},

			credits: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: {
				// type: 'logarithmic',
				plotLines: [{
					value: 0,
					width: 2,
					color: '#666'
				}],

				title: {
					text: (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + self.currency + (self.currency.toLowerCase().contains('gold') ? '' : 's'),
					style: {
						color: '#666'
					}
				},

				labels: {
					align: 'left',
					style: {
						color: '#666'
					},
					y: -5,
					x: 0,
					formatter: function formatter() {
						var currency_code = self._currency_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol;
						}

						return self.currency_symbol + Core.add_commas(this.value);
					}
				},
				gridLineWidth: 1,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				minPadding: 0,
				showLastLabel: true,
				opposite: false
			},

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 100,
					type: 'datetime',
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					},
					gridLineColor: '#888',
					gridZIndex: 4
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					animation: true,
					cursor: 'pointer',
					events: {
						click: function click(e) {
							if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
								if (e && e.stop) e.stop();
							}

							if (self.area == 'region') {
								self.show_by_region(this.name);
							} else {
								var data = {
									hood: this.name.toInt(),
									region: self.selected_region,
									type: self.type_id,
									beds: self.beds_id,
									currency: self.curr_id
								};

								Cookie.write('crNhStatsCriteria', JSONMOO.encode(data));

								if (self._element.get('data-nh-stats-url')) {
									location.href = self._element.get('data-nh-stats-url');
								}
							}
						},

						mouseOver: function mouseOver() {
							if (!this.button) {
								this.url = '';

								this.button = new Element('a', { 'class': 'button details', 'href': this.url, 'text': self.regions[this.name] + ' details' });

								this.button.addEvent('click', function (e) {
									if (e && e.stop) e.stop();

									this.button.dispose();
									this.fireEvent('click', this);
								}.bind(this));
							}

							if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
								self._element.getElement('.w_graph_body').adopt(this.button);
							}
						},

						mouseOut: function mouseOut() {
							if (this.button) {
								this.button.dispose();
							}
						}
					}
				},

				spline: {
					dataGrouping: {
						// smoothed: true,
						groupPixelWidth: 5,
						approximation: 'open',
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					},
					lineWidth: 3,

					states: {
						hover: {
							lineWidth: 5
						}
					},

					marker: {
						enabled: false,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}
			},

			tooltip: {
				useHTML: true,
				valueDecimals: 0,
				shared: false,
				crosshairs: false,
				borderWidth: 2,
				style: {
					width: '300px'
				},

				formatter: function formatter() {
					var details, c_price, h_price;
					var current = this.series.yData[this.series.yData.length - 1];
					var result = ((current - this.y) / this.y * 100).round(1);
					var currency_code = self._currency_select.getElement(':selected').get('value');

					var current_date = new Date();
					var fromDate = new Date(Highcharts.dateFormat('%b %e, %Y', this.x));
					var xy = self.date_difference(fromDate, current_date);

					if (currency_code == 'XAU') {
						if (this.y >= 0) {
							result = ((current - this.y) / this.y * 100).round(1);
						} else {
							result = ((current - this.y) * 100).round(1);
						}
						c_price = Core.add_commas(current.toFixed(1)) + ' ' + self.currency_symbol;
						h_price = Core.add_commas(this.y.toFixed(1)) + ' ' + self.currency_symbol;
					} else if (currency_code == 'RUB') {
						if (this.y >= 0) {
							result = ((current - this.y) / this.y * 100).round(1);
						} else {
							result = ((current - this.y) * 100).round(1);
						}
						c_price = Core.add_commas(current) + ' ' + self.currency_symbol;
						h_price = Core.add_commas(this.y) + ' ' + self.currency_symbol;
					} else {
						c_price = self.currency_symbol + Core.add_commas(current);
						h_price = self.currency_symbol + Core.add_commas(this.y.round());
					}

					var sign = current.round(1) >= this.y.round(1) ? '+' : '';
					result = sign + result.toString();

					details = '<div class="series_name" style="border-bottom-color:' + this.point.series.color + '">' + self.regions[this.point.series.name] + '</div><br/>' + '<span style="color:#333">Current Price: <b>' + c_price + ' / ft<sup>2</sup></b></span><br/><br/>' + '<span style="color:#333">Price on ' + Highcharts.dateFormat('%b %e, %Y', this.x) + ': <b>' + h_price + ' / ft<sup>2</sup></b></span><br/>' + '<span style="color:#333">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<label style="color:' + (sign == '+' ? 'green' : 'red') + '"/>' + result.toString() + '%</span><br/><br/>';

					if (Browser.platform != 'ios' && Browser.platform != 'webos' && Browser.platform != 'android') {
						details += self.area == 'region' ? '<span style="color:#333">Click for Neighborhood details</span><br/><br/>' : '<span style="color:#333">Click for Details</span><br/><br/>';
					}

					return details;
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		});
		this.series = this.chart.series;

		this._veil.hide();
		this.set_rangeselector();
		this.data_changed = false;
	},

	remove_serie: function remove_serie(name) {
		var show = false;

		this.chart.series.each(function (el) {
			if (el.name == name) {
				el.hide();
			}

			if (el.name != 'Navigator') show = show || el.visible;
		});

		this.display_warning(!show);
	},

	add_serie: function add_serie(name) {
		var self = this;
		var in_series = false;
		var show = false;

		this.chart.series.each(function (el) {
			if (el.name == name) {
				in_series = true;

				if (el.processedXData && el.processedXData.length > 0) {
					el.setVisible(true);
					el.show();
					show = true;
				} else {
					self.fireEvent('filter');
					return;
				}
			}
		});

		if (!in_series) {
			self.fireEvent('filter');
		} else {
			this.display_warning(!show);
		}
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate, toDate;
		var year, month, day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft - 15,
				    topPosition = this.chart.plotTop - 50,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 425,
					y: topPosition
				});

				leftPosition += this.zoomText.getBBox().width + 425;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 14
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	},

	get_rangedate: function get_rangedate() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.min_date = url.getData('date_from');
			this.max_date = url.getData('date_to');
		}
	},

	set_rangeselector: function set_rangeselector() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.chart.xAxis[0].setExtremes(new Date(url.getData('date_from')), new Date(url.getData('date_to')));
		}
	},

	display_warning: function display_warning(show) {
		if (show) {
			var msg = 'No data available for ' + this._beds_select.getElement(':selected').get('text') + ' apartments in the selected ' + (this.area == 'region' ? 'regions' : 'neighborhoods');

			this._warning.set('text', msg);
			this._warning.show();
			this._graph_cont.hide();
		} else {
			this._warning.hide();
			this._graph_cont.show();
		}
	},

	show_by_region: function show_by_region(region_id) {
		this.selected_region = region_id;
		this.build_legends();
		this.update_header();
	}
});
//# sourceMappingURL=mid.js.map
